export default {
  default: {
    portal: {
      nav: {
        home: 'Home',
        contactUs: 'Contact Us',
        contactUsUrl: 'https://en.chief.com.tw/demandform/',
        myAccount: 'My Account',
        login: 'Sign In',
        logout: 'Sign Out',
        registerQuery: 'Registration Progress Query',
        createAccount: 'Create a new account',
        lastestNews: 'Latest News',
        products: 'Products',
        productExtra1: 'Chief Global BMC Cloud Services',
        productExtra2: 'Chief CCIS Zone2',
        solution: 'Solutions',
        solutionVpc: 'Chief Virtual Private Cloud',
        solutionCloud: 'Chief Cloud Integrated Storage Service',
        solutionCount: 'Chief Virtual Dedicated Server',
        pricing: 'Pricing',
        documentDownload: 'Documentation',
        webMap: 'Sitemap',
        privacyRightDeclare: 'Privacy Policy',
        personalProfileProtect: 'Personal Information Protection',
        cookiePolicy: 'Cookie Policy',
        fraudPrevent: 'Fraud Prevention',
        copyrightDeclare: 'Proprietary Rights',
        securityPolicy: 'Information Security Policy',
        cloudDeclare: 'Cloud Service Statement',
        summary: 'Overview',
        functions: 'Function',
      },
      header: {
        title: 'CHIEF TELECOM',
      },
      footer: {
        address: 'Chief Telecom Inc. 2F, No. 68, Ruiguang Rd., Nei-hu Dist. Taipei 114062, Taiwan',
        telephone: '070-1018-6688 02-2657-6688',
        copyright: 'COPYRIGHT@2023 CHIEF TELECOM INC. ALL RIGHTS RESERVED',
        facebook: 'Facebook',
        youtube: 'Youtube',
        cookieText1: 'Your experience about visiting our Website will be raised by providing your cookies info. Please read our',
        cookieText2: 'Cookie Policy about our Cookies Settings. If you choose “Agree” option, it means that you agree us to use as well as store your cookies record and information; if you choose “Reject” option, we may still use the minimum cookies information for your Website visit.',
        agree: 'Agree',
        reject: 'Reject',
      },
      pageHome: {
        title: 'Explore Our Solutions',
        readMore: 'Read More',
      },
      pageLogin: {
        loginTypeRootLabel: 'Root user',
        loginTypeRootDescription: 'Account owner that performs tasks requiring unrestricted access.',
        loginTypeIAMLabel: 'IAM user',
        loginTypeIAMDescription: 'User within an account that performs daily tasks.',
        forgetPassword: 'Forgot password',
        login: 'Sign In',
        twoFATitle: 'confirm your identity',
        twoFADescription1: 'Keeping you safe - that is our responsibility.',
        twoFADescription2: 'We have sent an email with a verification code to',
        twoFADescription3: '.',
        twoFADescription4: 'Please enter the captcha below to confirm your email.',
        verify: 'verify',
        resendVerifyCode: 'resend verification code',
        notReceiveVerifyCodeTitle: 'Did not receive the verification code?',
        notReceiveVerifyCodeDescription1: 'You will receive a verification code within 5 minutes.',
        notReceiveVerifyCodeDescription2: 'Please check your spam folder',
        twoFARetrySuccess: 'Verification code has been resent to{{email}}！', 
        formFields: {
          account: 'Root user email address',
          password: 'Password',
          root: 'Account ID (11 digits)',
          iamAccount: 'IAM account alias',
          tfa_code: 'verification code',
        },
      },
      pageForgetPassword: {
        forgetPassword: 'Forgot password',
        resetPassword: 'reset Password',
        or: 'or',
        login: 'Sign In',
        successfully: 'A reset password link has been sent to',
        returnToHome: 'Back to home',
        formFields: {
          email: 'Primary Contact Email',
        },
      },
      pageRegister: {
        registerAccount: 'Create a new account',
        rootEmail: 'Root user email address',
        rootEmailNote: 'For account recovery and some administrative functions',
        rootEmailLabel: 'Please enter account email',
        validateEmail: 'Verify email address',
        or: 'or',
        login: 'Sign In',
        successfully: 'A verification link has been sent to',
        returnToHome: 'Back to home',
        formFields: {
          email: 'Root user email addres',
        },
      },
      pageRegisterQuery: {
        registerQuery: 'Registration Progress Query',
        validateEmail: 'Get registration progress information',
        or: 'or',
        login: 'Sign In',
        successfully: 'A registration inquiry link has been sent to',
        returnToHome: 'Back to home',
        formFields: {
          email: 'Primary Contact Email',
        },
        queryProgress: 'Registration progress',
        queryResult: {
          REGISTER_NOT_COMPLETED: 'Incomplete registration',
          REGISTER_UNDER_REVIEW: 'under review',
          REGISTER_DENIED: 'rejected',
          REGISTER_COMPLETE: 'completed',
        },
      },
      pageRegisterInfoInput: {
        registerInfoInput: 'Registration Basic Information',
        basicData: 'Basic Information',
        contactInfo: 'Contact Information',
        billInfo: 'Account Information',
        fileUpload: 'Certificate Upload',
        supplyInfo: 'Supplementary Information',
        basic: 'required',
        improved: 'Advanced Information',
        returnToHome: 'Back to home',
        submit: 'Save',
        reset: 'Reset',
        confirmUploadTitle: 'Confirm send',
        confirmUpload: 'The upload of the certificate is incomplete, do you confirm that the information is sent?',
        successfully: 'The registration information has been sent successfully, please wait patiently for review!',
        companyNameNotify: 'Please be consistent with the name on the registration certificate of the company/organization, otherwise the registration may fail. (If habitude is PERSONAL, you can ignore this field)',
        formFields: {
          main_mail: 'Primary Contact Email',
          identity_type: 'habitude',
          identity_number: 'Unified number/ID number',
          company_name: 'Full company name',
          company_shortname: 'Company abbreviation',
          en_company_name: 'English full name',
          en_company_shortname: 'English abbreviation',
          company_owner: 'Principal',
          contact_name: 'Primary contact',
          contact_mobile_code: 'Primary contact mobile number country code',
          contact_mobile: 'Primary contact mobile number (start with zero)',
          tech_contact_mail: 'Technical contact email',
          contact_tel_code: 'Primary contact company phone country code',
          contact_tel: 'Primary contact company phone',
          contact_tel_ext: 'Primary contact company phone ext.',
          cman_dmfg: 'DM sent by the primary contact',
          bill_contact_name: 'Account contact',
          bill_contact_tel_code: 'Account contact company phone country code',
          bill_contact_tel: 'Account contact company phone',
          bill_contact_ext: 'Account contact company phone ext.',
          bill_contact_mobile_code: 'Account contact mobile number country code',
          bill_contact_mobile: 'Account contact mobile number',
          bill_dmfg: 'DM sent by the account contact',
          bill_contact_mail: 'Account contact Email',
          tech_contact_name: 'Technical contact',
          tech_contact_tel_code: 'Technical contact company phone country code',
          tech_contact_tel: 'Technical contact company phone',
          tech_contact_ext: 'Technical contact company phone ext.',
          tech_contact_mobile_code: 'Technical contact mobile number country code',
          tech_contact_mobile: 'Technical contact mobile number',
          tech_dmfg: 'DM sent by the technical contact',
          currency_type: 'Currency',
          language: 'Language',
          industry_type: 'Industry',
          bill_address: 'Billing address',
          is_foreign: 'Domestic/Foreign',
          area: 'Region',
          receipt_lottery_title: 'Invoice',
          en_address: 'English address',
          receipt_lottery_address: 'Invoice address',
          doc1: 'identity photo 1',
          doc2: 'identity photo 2',
          doc3: 'identity photo 3',
          doc4: 'identity photo 4',
          companyDoc3: 'certificate of incopocation 3',
          companyDoc4: 'certificate of incopocation 4',
          tel_code: 'phone 1 country code',
          tel: 'phone 1 ',
          tel_ext: 'phone 1 ext.',
          tel2_code: 'phone 2 country code',
          tel2: 'phone 2',
          tel2_ext: 'phone 2 ext.',
          tel3_code: 'phone 3 country code',
          tel3: 'phone 3',
          tel3_ext: 'phone 3 ext.',
          fax: 'Fax 1',
          fax2: 'Fax 2',
          fax3: 'Fax 3',
          mail: 'E-mail',
        },
        commercialNatureEnum: {
          'COMPANY': 'COMPANY',
          'PERSONAL': 'PERSONAL',
        },
        dmEnum: {
          'C': 'Chinese',
          'E': 'English',
          'X': 'Do not send',
        },
        industryTypeEnum: {
          '10': 'Others',
          '11': 'Publishing Activities',
          '12': 'Medical and Social Services',
          '20': 'Financial and Insurance Activities',
          '21': 'Manufacture of Semi-conductors',
          '22': 'Manufacture of Machinery',
          '23': 'Manufacture of Electronics',
          '24': 'Manufacture of Chemical and petrochemical',
          '25': 'Manufacture of Food Products',
          '26': 'Manufacture of Auto Parts',
          '27': 'Manufacture of Textile',
          '28': 'Manufacture of Other',
          '29': 'Pharmaceutical and medical material biotechnology industry',
          '30': 'Business Consulting Services',
          '31': 'Government Agencies',
          '32': 'Local agency',
          '41': 'Media industry',
          '50': 'Foreign telecom operators',
          '51': 'Domestic telecom operators',
          '52': 'Voice wholesale',
          '53': 'General ICP industry',
          '55': 'Manufacturing',
          '56': 'Wholesale and retail trade',
          '57': 'Information and Communication',
          '58': 'Accommodation and Tourism',
          '59': 'Transportation and warehousing',
          '60': 'Education supplementary work',
          '61': 'Leisure and entertainment service industry',
          '62': 'Internet and Cloud Operators',
        },
        isForeignEnum: {
          '0': 'Domestic',
          '1': 'Foreign',
        },
        areaEnum: {
          'TWNCENTRAL': 'Central Taiwan',
          'TWNNORTH': 'Northern Taiwan',
          'TWNSOUTH': 'Southern Taiwan',
        },
        termsOfService: 'Terms of Service\n\nAwareness and acceptance of terms\n1.	Chief Telecom Inc. (hereinafter referred to as "Chief") is to provide Cloud Service Customer Portal (hereinafter referred to as "the service") in accordance with these terms of service. When a member completes the registration procedures or starts to use the service, it means that he has read, understood and agrees to accept all the contents of the terms of service, and fully accept the current and future derived service items and contents of the service already. Chief has the right to modify or change the content of these terms of service from time to time and at any time. The content of the revised terms of service will be announced and published on the relevant website. Chief will not notify members individually. Members are advised to pay attention to such modifications or changes at any time. When a member continues to use this service after any modification or change, it is deemed that the member has read, understood, and agrees to accept such modification or change. If you do not agree to the above-mentioned service terms revision or update method, or do not accept any other agreement of the service terms, the member should stop using the service immediately.\n2.	If the member is under the age of 18 in Taiwan or belongs to the underage person in other country, the member’s parent (or legal guardian) shall read, understand and agree to all the contents of this agreement and its amendments before registration to use or continue to use this service. When a member uses or continues to use the service, it is presumed that the member’s parent (or legal guardian) has read, understood and agreed to accept all the contents of this agreement and its amendments.\n3.	Both of Chief and its members agree to use all content of this service, including but not limited to manifestation of intention or notice, by using electronic files as the means of expression.\n4.	For the protection of your personal information, Chief hereby informs you of Chief’s collection, processing and use of your personal information within the minimum purpose and scope below pursuant to Article 8 of Taiwan Personal Information Protection Act and other applicable statutes.\n•	Purpose of Collection\nChief, pursuant to the provisions of Taiwan Personal Information Protection Act and the other applicable statutes, collects your personal information for the purposes as below: marketing, non-government agency’s collection, processing and use of personal information based on legal obligations, contractual, quasi-contractual or other legal relationship matters, consumer, customer management and service, consumer protection, business technical information,\n•	Classification of Personal Information\nChief collects the information provided by you, including the name, company, department, job title, contact details, including but not limited to, fax numbers, e-mail or address, or any other personally, directly or indirectly, identifiable information.\n•	Time Period, Area, Target and Way of the Use of Personal Information\n(1) Time Period: the existence period of Chief, data retention period or necessary data retention period for Chief’s execution of business. (2) Area: the Territory of Taiwan and the domestic and foreign locations of the Use Target. (3) Subject: Chief, the parent company or subsidiaries, the company which controls Chief or controlled by Chief, or Chief holds certain percentage of shares or has the actual control relationship with Chief (hereinafter collectively referred to as "Chief’s Affiliates"), or Chief’s jointly marketing and cooperative partners, other institutions having business contract or cooperation with Chief, competent authority, the institutions, organizations or groups having legal investigation right. (4)	Way: Chief will use appropriate ways, including but not limited to by telephone, text message, email, written document to collect, process the cross-border transmission or use of your personal information. And it will be limited to the minimum necessary scope.\n•	The Rights with regard to Your Personal Information\n(1) Any inquiry and request for a review or making duplications of your personal information, provided that Chief may charge a reasonable fee; (2) Any request to supplement or correct your personal information; (3) Any request to delete, discontinue collection, processing or use of your personal information when the specific purpose no longer exists or time period expires; without any interference with Chief’s necessary performance of the service; (4) Chief may use your personal information for marketing activities, upon receiving your rejection on such marketing activities, Chief will discontinue to use your personal information for marketing within a reasonable period of time; and (5) According to EU General Data Protection Regulation (GDPR), the following rights shall be exercised by you, not to interfere with the specific purpose and required scope of personal information collection, with regard to your personal information: right of access by the data subject, right to rectification, right to erasure (right to be forgotten), right to restriction of processing, right to data portability, right to object.\n•	To protect Customer’s personal information, Chief has designated Information Security Committee as internal organization. If you have any inquiry, please email: tim_chiang@chief.com.tw.\n•	Caution! If you refuse to provide the necessary information required to join the membership, it may result in the inability to use the full service or completely unable to use the service.\n\nMember’s registration obligations\nIn order to use this service, members shall agree with the following:\n•	Provide the correct and up-to-date information and shall not register as the name of a third person. Each member can only register and log in to one account, and not allowed to register and log in repeatedly.\n•	Immediately maintain and update the member’s personal information to ensure its correctness to obtain the best service.\n•	If the member provides any wrong or false information, or fails to provide the information as instructed, or lacks necessary information, or repeats the account registration etc., Chief has the right to suspend or terminate the member’s account without prior notice and refuse members to use all or part of this service.\n\nPayment, Application and Variation\n•\tCustomer shall pay Chief the charge of one-time initial installation and all cloud services in accordance with the applied service items for leasing Cloud Service via this Cloud Service Customer Portal. Please refer to Chief Cloud Service Customer Portal website for the pricing table.\n•\tThe Charge of metered service shall be calculated on monthly basis. Any charge shall be calculated and collected on the basis of Customer’s actual usage.\n•\tContract-type service billing is mainly based on the agreed contract period (such as initial/commitment term). The application and the services provided hereunder will be terminated on the designated Termination Date if Customer has finished all the termination processes requested by Chief. In such circumstances, Customer shall pay all unpaid service charges as well as the Early Termination Charges of the total amount of Service Charges for the entire remaining service term of the relevant services.\n•\tChief shall invoice Customer before the fifth day of each month for the Charges. Customer shall pay the charges in cash or tele-wire within the 15 days of each month and facsimile the remittance slip to Chief. The invoice address is specified in Chief’s customer database system. Customer shall notify Chief in writing with notice made or via e-mail if the invoice address needs to be updated or changed. After receiving the invoice, if Customer shall not have a dispute concerning the amount written notice or via e-mail within 5 days, Customer shall pay all amounts then due. With respect to the contract-type service, in the event that the Commencement Date is a day other than the first day of a calendar month, the Charge will be incorporated into the invoice of next month.\n•\tThe Charges shall be paid in accordance with the application. Chief shall be entitled to amend the Charges by 30 days prior notice to Customer and invoiced Customer the amended charge from the effective date.\n•\tIn the event that the Customer fails to make full payment more than three (3) days after the due date, Chief shall be entitled to suspend all or part of the service, including but not limited to suspension of license or operating authority.\n•\tCustomer may request the variation of contract-types service by applying in Cloud Service Customer Portal. If the total amount of Service Charge changes, the amount of Service Charge and the Commencement Date has to be indicated and shall be charged in accordance with the basic service items and value-added services.\n•\tWith respect to contract-type service, Customer may terminate the application by notifying Chief in writing or via e-mail no less than 30 days prior to the end of the initial/commitment term. Without such notice of termination, then the application shall be automatically renewed for another initial/commitment term likewise. Customer may terminate the application at any time during the Renewal Term, providing Chief a thirty (30) days written notice or via e-mail prior to the designated Termination date. The application and the services provided hereunder will be terminated on the designated Termination Date if Customer has finished all the termination processes requested by Chief. In such circumstances, Customer shall pay all unpaid service charges as well as the Early Termination Charges of the total amount of Service Charges for the entire remaining service term of the relevant services.\n\nPrivacy Policy\nMember registration and other specific information are protected and regulated by Chief’s “Privacy Policy.\n\nThe user’s legal obligations and commitments\nMembers promise not to use this service for any illegal purpose or in any illegal way, and promise to abide by the relevant laws and regulations of the Republic of China and all international practices for using the Internet. Members agree and guarantee\n\nthat they shall not use this service to engage in acts that infringe on the rights of others or violate the law, including but not limited to:\n•\tPublish or transmit any defamatory, insulting, threatening, offensive, indecent, obscene, false, contrary to public order or good customs, or other illegal text, pictures or any form of file\n•\tInfringe or damage the reputation, privacy, commercial confidential information, trademark rights, copyrights, patent rights, other intellectual property rights and other rights of Chief or others\n•\tViolation of law or contract, or infringement of confidentiality obligations under the law or contract\n•\tUse this service with false impersonation.\n•\tTransmission or distribution of computer viruses\n•\tEngaging in business activities without prior authorization from the Chief.\n•\tPublish, transmit, send spam, chain letters, illegal or unauthorized multi-level marketing messages and advertisements, etc.; or store any information that infringes on the intellectual property rights of others or violates laws and regulations\n•\tOffensive behaviors that cause confusion and discomfort to other users of this service or third parties.\n•\tOther behaviors that do not meet the purpose of use provided by this service or inappropriate behaviors judged by Chief for legitimate reasons.\n\nChange of service content and delivery of e-newsletters and EDM\n1.\tThe member agrees to the scope of the service provided by Chief. Chief may increase, decrease, change or terminate the related service items or content according to business needs and actual conditions, and there is no need to notify the member individually.\n2.\tThe member agrees that Chief will add, modify or terminate related activities according to the actual implementation situation, and Chief will take the most suitable method to inform the member.\n3.\tThe member agrees that Chief will send newsletters or EDM from time to time to the member’s e-mail account. When the member refuses to accept the marketing information after receiving the message, Chief will stop sending marketing related messages.\n\nStop and Interruption of Services\nChief will maintain the normal operation of the system and services in accordance with generally reasonable techniques and methods. However, Chief has the right to stop or interrupt the provision of this service in the following situations:\n•\tWhen Chief comes to the website for necessary maintenance and construction of electronic communication equipment\n•\tWhen a sudden electronic communication equipment failure occurs\n•\tWhen the electronic communication service of the website that Chief apply is stopped to provide.\n•\tWhen Chief is unable to provide services due to natural disasters, other force majeure factors or other factors that are not attributable to Chief\n\nLimitation and Exclusion of Liability\n1.\tThe functions of this service are provided for use according to the current status of the function at the time. Chief does not bear any explicit or implied responsibility regarding its performance, speed, completeness, reliability, safety, accuracy, etc.\n2.\tChief does not guarantee that the e-mails or its contents from the webpages, servers, domain of this service will not contain harmful parts such as computer viruses; nor does it guarantee that the transmission and storage of mails, files or data are correct without disconnection and errors. Chief shall not be liable for damages caused by the failure, loss or error of the mail, file or data transmission or storage.\n\nProtection of intellectual property rights\n1.\tThe software or programs used by Chief, and all content on the website, including but not limited to works, pictures, files, information, data, website architecture, webpage arrangement, and web design, are all from Chief or other right holders who own intellectual property rights, including but not limited to trademark rights, patent rights, copyrights, commercial confidential information and know-how. If members want to apply or reprint above software, programs or website content, they must obtain prior written consent from Chief or other rights holders in accordance with the law. Respect for intellectual property rights is an obligation of members. If there is a violation, members shall be liable for all damages to Chief, including but not limited to litigation costs and attorney expenses.\n2.\tUnder the principle of respecting the intellectual property rights of others, members agree not to infringe on the intellectual property rights of others when using the services from Chief.\n3.\tIf the member is involved in infringement, Chief can suspend all or part of the service, or cancel the member account directly.\n\nAuthorization\nRegarding the information uploaded, transmitted, input or provided by the member, the member agrees that except the personal data and information, Chief can collect, process, store, transmit and use such information within a reasonable scope to provide users with information or services, or to create member statistics, or conduct investigations or research on Internet user behavior, or for any legal use. Once any information is uploaded, transmitted, entered or provided to Chief by the member, it shall be deemed that the member has allowed Chief to use unconditionally, modify, reproduce, broadcast, remake, distribute and publish such information and to transfer the aforementioned rights to others. The members have no objection to this. Members shall also ensure that Chief does not infringe the intellectual property rights of any third party when it uses, modifies, reproduces, broadcasts, remakes, distributes, publishes and authorization transfer such information; otherwise, members shall be liable for all damages to Chief.\n\nSuspending or terminating your access to the services\nThe member agrees that Chief can terminate the member’s password, account (or any part thereof) or the access to this service (or any part thereof), or remove and delete any \"member content\" of this service based on the consideration of maintaining transaction security for any rational reason, including but not limited to lack of use, or violation of the express provision and spirit of the terms of service. In addition, the member agrees that if the access of this service (or any part thereof) is terminated, Chief shall not, expressly or impliedly, be liable to the member or any third party or any derivatively direct or indirectly obligation accordingly.\n\nGoverning Law and Jurisdiction Court\nBoth parties hereof agree that any dispute arising here from shall be governed by Taiwan law and the Taiwan Shilin District Court shall have jurisdiction over and be the court of first instance therefor.',
        privacyPolicy: 'Privacy Policy\n\nChief Telecom Inc. (“Chief”) fully respects and protects your privacy rights.\n For your understanding of how Chief collects, uses, and protects your personal information, please carefully read the following, “Chief Privacy Policy”, which will tell you about the information collected by Chief on the websites of Chief (“Chief Websites), and how Chief uses this information. Chief will not collect any personal information about you on this website, apart from any personal information that you provided voluntarily, either by emailing us or by submitting the online forms. The personal information received from the website hereunder shall be kept in confidential by Chief. \n\nThe Information that Chief Collects\n Generally, it is not necessary to provide any personal information when each visitor views our content on Chief’s website. Unless you have been fully informed, Chief will not collect any personal information about the visitor. Chief will not collect the IP Address and Cookie(s) of visitors. Chief will also not track, analyze and/or record visitors’ browsing history actively. Unless it is necessary, Chief will set a bar across the top of the website or use pop-up window informing each visitor that the purpose of the collection and obtaining visitor’s consent. \n1. On-line Activities and Network Surveys When you participate in any online activity, or any network survey carried out on the Chief Web sites, Chief may request you to provide your personal information, such as your name, identification number, phone number, email address, address, etc. \n2. Registering with Websites When you actively register with any website, or edit your personal information on Chief’s search engine, Chief will, due to the necessity of operation, retain your information, such as your email address, and the description about the website. \n3. The Service of Internet Content In the event that you register with the Chief Websites, and become a member thereof, Chief will, in accordance with the nature of the service provided by the website which you register with, request you to provide your personal information, including but not limited to your name, nickname, address, phone number, email address, etc.\n\n Chief Policy for the Use of the Information that Chief Collects\n 1. On-line Activities and Network Surveys The names and identification numbers of the participants, collected by Chief due to on-line activities and network surveys, will only be utilized for the purposes of commercial contact or the related lotteries. Except for notifying the participants of the outcome of the lottery, or for conducting the analysis, the participants’ information, such as phone numbers, email addresses, and addresses thereof will not be utilized. Chief will confine the use of the participants’ information limited into commercial contact, internal market or data analysis, or an academic purpose. Chief will not use the aforesaid information for any other purposes. Chief will not publicize any information concerning any individual participant.\n2. Miscellaneous Chief will only use the information that you provide, while voluntarily registering with the Chief Websites to be a member thereof, for reference in order to provide you with services, and plan any kind of activities. Any personal information, which you provided via the website, is for Chief internal use only, within the period of service provision and under the specific purpose and required scope of personal information collection. Chief will not pass the information to any other third party or use for other purposes unless Chief has informed you clearly before and obtained your prior consent, or pursuant to the applicable laws. Except otherwise provided herein, Chief shall not disclose to any other third party: (i) in compliance with applicable laws and regulations of administrative authorities or court orders; (ii) to protect the legitimate rights of others; (iii) to maintain the normal operation of the service system. \n\nChief Policy for Sending Commercial Information and Emails \nChief will send the commercial and/or promotional information or emails (“Chief Commercial Information”), to you after getting your permission that you give upon your registration, or your prior consent. In the Chief Commercial Information, Chief will declare Chief is the sender thereof, and provide you with the method, explanation, and contact information that you need to cease receiving the Chief Commercial Information from time to time. \n\nRights \nAccording to Taiwan Personal Information Protection Act (PIPA), the following rights shall be exercised by you, not to interfere with the specific purpose and required scope of personal information collection, with regard to your personal information: any inquiry and request for a review, any request to make duplications, any request to supplement or correct, any request to discontinue collection, processing or use, any request to delete. According to EU General Data Protection Regulation (GDPR), the following rights shall be exercised by you, not to interfere with the specific purpose and required scope of personal information collection, with regard to your personal information: right of access by the data subject, right to rectification, right to erasure (right to be forgotten), right to restriction of processing, right to data portability, right to object. \n\nSelf-Protection\n Please take care of your password, or any other personal information, and do not disclose your personal information, especially your password, to any third party. After you complete the process of ordering, shopping or receiving email, it is recommended that you logout of your account. If you share the computer with others, or use a public computer, please remember to logout of your account and close the browsing window in order to prevent others from accessing your personal information, or reading your email. Chief has owned the information security certification of ISO27001, 27011, 27017 and 27018, and keeps endeavoring to strengthen technic and appropriate measures in order to protect your personal information. \n\nChanges\n Chief may update this Privacy Policy from time to time. In order to protect your interest and right, please check it periodically.\n\n Questions concerning Chief Privacy Policy\n If you have any questions about the protection of your privacy rights on Chief Websites, please contact Chief Customer Service Center or designated Personal Information email contact: tim_chiang@chief.com.tw.',
        agreementText: 'To protect your rights, please read all the content of the website’s membership terms carefully. When you select the ‘Agree’ option, it will be considered that you have read, understood, and agreed to comply with the above service terms.',
      },
      pageResetPassword: {
        resetPassword: 'reset Password',
        confirm: 'Save',
        confirmPasswordNotMatch: 'Password and confirmation password do not match!',
        successfully: 'Password reset complete',
        returnToLogin: 'back to sign in page',
        formFields: {
          password: 'Password',
          check_password: 'Confirm Password',
        },
      },
      pageSetPassword: {
        setPassword: 'Set Password',
        confirm: 'Save',
        confirmPasswordNotMatch: 'Password and confirmation password do not match!',
        successfully: 'Set password complete',
        goToLogin: 'back to sign in page',
        formFields: {
          password: 'Password',
          check_password: 'Confirm Password',
        },
      },
      pageProduct: {
        overview: 'Overview',
        functions: 'Function',
        price: 'Price',
      },
    },
    console: {
      /** layout header */
      header: {
        home: 'Home',
        cloudPortal: 'Cloud Portal',
        contactUs: 'Contact Us',
        supports: 'Support',
        myAccount: 'My Account',
        clientNumber: 'Client Number:',
        myInfo: 'Account Settings',
        myTicket: 'Contact Chief Service',
        orderManage: 'Order Manage',
        logout: 'Sign Out',
      },
      /** layout sidebar */
      sidebar: {
        /** level 1 group */
        iamManage: 'IAM Management',
        platform: 'Compute Platform',
        ccis: 'CCIS',
        nets: 'Networking',
        matrix: 'Chief CloudMonitor',
        costInquery: 'Cost Explorer',
        /** level 2 group */
        snapshot: 'Snapshots',
        netsManager: 'Network Management',
        /** page link */
        iamUsers: 'IAM Users',
        dashboard: 'Dashboard',
        vmSetting: 'Chief Virtual Machines',
        disk: 'Volumes',
        snapshotList: 'Snapshots',
        snapshotRule: 'Snapshot Policies',
        vni: 'VNIs',
        firewall: 'Firewall Policies',
        balancer: 'Load Balancers',
        orderHistory: 'Order History',
        purchaseCCIS: 'Purchase Data Store',
        bucket: 'Buckets',
        usageReport: 'Usage Report',
        vpcNets: 'Your VPCs',
        ccx: 'Chief Cloud eXchanges',
        matrixData: 'Metrics',
        alarm: 'CloudWatch Alarms',
        exCloud: 'Public Cloud Resources',
        valuation: 'Monthly Charge Valuation',
        singleVM: 'Single VM Metrics',
        totalUsage: 'Usage Metrics',
      },
      pageMyInfo: {
        enabled: 'Enabled',
        disabled: 'Disabled',
        confirmTitle: 'Modify personal information?',
        confirmText: 'If you are sure you want to modify your personal information, please click the Save button below.',
        cancelTitle: 'Give up modifying personal information?',
        cancelText: 'If you are sure you want to give up modifying your personal information, please click the confirmation button below.',
        hintRoot: 'Please note: If you want to modify the basic information, please contact the local customer service personnel!',
        hintIAM: 'Please note: If you want to modify the basic information, please log in with Root authority and then contact the customer service staff!!',
        contact: 'Contact Chief Service',
        submit: 'Save',
        cancel: 'Cancel',
        formFields: {
          identityNumber: 'tax ID number',
          companyName: 'Full company name',
          clientNumber: 'Account ID (11 digits)',
          twoFa: '2FA',
          email: 'Email',
          pass0: 'original password',
          pass1: 'change Password',
          pass2: 'confirm change Password',
        },
      },
      pageMyTicket: {
        title: 'Issues',
        actions: {
          createTicket: 'Add Issue',
        },
        dataFields: {
          ticketNo: 'Issue No',
          contactName: 'primary contact',
          vmId: 'VM ID',
          ccisId: 'CCIS ID',
          ticketCode: 'Issue code',
          ticketRemark: 'Issue message',
          tkNumber: 'Issue no：',
          tkStatus: 'Response code：',
          tkHistory: 'Response message：'
        },
        tkStatus: {
          CLOSE: 'Close',
          NEW: 'New',
          WAITING: 'Waiting',
          PROCESS: 'Process',
        },
      },
      pageCreateTicket: {
        title: 'Add Issue',
        submit: 'Save',
        cancel: 'Cancel',
        none: 'None',
        confirmTitle: 'Add Issue?',
        confirmText: 'If you are sure you want to add Issue, please click the Save button below.',
        formFields: {
          identityNumber: 'tax ID number',
          companyName: 'Full company name',
          clientNumber: 'Account ID (11 digits)',
          contactName: 'primary contact',
          contactMail: 'primary contact email',
          contactMobile: 'primary contact mobile number',
          contactTel: 'primary contact phone',
          vmId: 'VM ID',
          ccisId: 'CCIS ID',
          vmOrCcisRequired: 'Both Virtual Machine and Chief Cloud Integrated Storage Service must fill in one of them.',
          ticketCode: 'Issue code',
          ticketRemark: 'Issue message：',
          ticketRemarkHint: 'If multiple Virtual Machines and Chief Cloud Integrated Storage Service are reported for repair at the same time, please list them in detail below.',
          uploadImageHint: 'If you need to attach a screenshot, please press [Save] to obtain the repair order number, and mail the relevant screenshot to the customer service mailbox of our party: service@chief.com.tw and indicate the repair order number, thank you!',
        }
      },
      pageOrderManage: {
        title1: '歷史訂單列表',
        title2: '歷史訂單 列表',
        actions: {
          /** cancel order dialog */
          cancelOrder: '解約訂單',
          cancelOrderTitle: '確定解約訂單「{{id}}」嗎？',
          cancelOrderText1: '是否確認要解約「{{id}}」訂單？',
          cancelOrderText2: '請注意：解約後，年約訂單將轉為隨需訂單。',
          resUuid: '資源編號：{{resUuid}}',
          resType: '資源類型：{{resType}}',
          resTypeEnum: {
            vm: '虛擬機',
            ccis: 'CCIS',
          },
          orderEDate: '訂單到期日：{{orderEDate}}',
          password: '若確認要解約，請在下方文字框中輸入登入密碼確認',
          cancelOrderPassword: '請輸入密碼確認要刪除',
          /** convert order dialog */
          convertOrder: '轉換訂單',
          vmUuid: '請選擇欲轉換年約制之虛擬機',
          contractId: '合約期間',
          convertOrderText1: '是否確認要轉換成年約制訂單？',
          convertOrderText2: '請注意：轉換成年約制訂單後即不能再更改規格，也無法刪除，關機與重開等操作可正常使用，請在轉換前先確認好該虛擬機的規格再進行轉換!!',
          convertOrderText3: '若確認要轉換，請在下方文字框中輸入登入密碼確認',
          convertOrderPassword: '請輸入密碼確認要轉換(要加上一個解約-先預設訂單到期日)',
          /** other */
          submit: '送出',
          cancel: '取消',
          createOrder: '新增年約制訂單',
        },
        dataFields: {
          id: '訂單編號',
          resUuid: 'VM/CCIS UUID',
          resName: 'VM/CCIS 名稱',
          contractMonth: '合約期間',
          contractMonthText: '{{n}}個月',
          orderDate: '訂單開始日',
          orderEDate: '訂單到期日',
          status: '訂單狀態',
          statusEnum: {
            1: '正常',
            2: '即將到期',
            3: '已到期解約',
            4: '已刪除',
            5: '作廢',
            6: '已刪除未滿7日',
            7: '已解約未滿7日',
          },
        },
      },
      pageOrderCreate: {
        title1: '新增年約制訂單',
        title2: '建立年約制虛擬機',
        confirmTitle: '新增年約制虛擬機？',
        confirmText: '若確定要新增年約制虛擬機，請點擊下方確認按鈕。',
        submit: '送出',
        cancel: '取消',
        note: '修改防火牆時無法建立虛擬機',
        formFields: {
          contractId: '合約期間',
          comboId: '組合方案',
          comboNote1: '1. 年約制訂單一旦建立即無法更改規格也無法調整訂單內容，只能自己關機但無法刪除，若須調整需要聯絡客服。',
          comboNote2: '2. 年約制時間到會自動續約，若需解約請在即將到期時解約，已自動續約之訂單需要解約請聯絡客服。',
          tagName: '名稱 (Name Tag)',
          tagNamePlaceholder: '請輸入名稱與標籤(例：my-vm-gateway-01)',
          osName: '作業系統',
          osVersion: '作業系統版本',
          cpuCore: 'vCPU：',
          cpuCoreNote: '2-64 core',
          core: 'Core',
          ramSize: '記憶體：',
          ramSizeNote: '4-256 GB 記憶體GB不得低於CPU數, 且不得大於CPU數之8倍',
          gb: 'GB',
          vpcId: 'VPC',
          createVPC: '建立VPC',
          firewallId: 'Firewall',
          createSecurityGroup: '建立防火牆',
          isAutoAssignPublicIP: '自動指派公有IP',
          enableEnum: {
            'Y': '啟用',
            'N': '停用',
          },
          dataDisks: '設定儲存：',
          dataDisksNote: '預設「根磁碟區」作業系統最小需50GB。',
          improvedInfo: '進階資訊',
          hypervisorId: '平台',
          enableAutoRecover: '虛擬機自動復原',
          enableTerminationProtection: '終止保護',
          enableStopProtection: '停止保護',
        },
      },
      pageIAMManage: {
        title: 'IAM Users',
        enabled: 'Enabled',
        disabled: 'Disabled',
        actions: {
          createIAM: 'Add IAM User',
          editIAM: 'Edit IAM User',
          destroyIAM: 'Delete IAM User',
          confirmDestroyTitle: 'Delete IAM User?',
          confirmDestroyText: 'Are you sure you want to「Delete IAM User」{{account}}?',
        },
        dataFields: {
          id: 'User ID',
          account: 'User name',
          roles: 'Roles',
          email: 'Email',
          lastSetPasswordDate: 'Password last modified time',
          lastLoginDate: 'Console last sign-in',
          enableTwoFactor: '2FA',
          isLock: 'state',
        },
      },
      pageUpsertIAM: {
        accountPlaceholder: 'Please enter the login account (only English letters are accepted regardless of case and numbers, dots and underlines).',
        passwordPlaceholder: 'Please enter the password (at least 12 characters including uppercase and lowercase letters, numbers and special symbols).',
        confirmPasswordNotMatch: 'The password does not match the confirmation password!',
        enabled: 'Enabled',
        disabled: 'Disabled',
        submit: 'Save',
        cancel: 'Cancel',
        formFields: {
          account: 'User name',
          email: 'E-mail',
          roles: 'Roles',
          enableTwoFactor: '2FA',
          isLock: 'State',
          password: 'Password',
          checkPassword: 'Confirm Password',
        },
        pageCreate: {
          title: 'Add IAM user',
          confirmTitle: 'Add IAM user?',
          confirmText: 'If you are sure to add IAM user, please click the Save button below.',
        },
        pageEdit: {
          title: 'Edit IAM User',
          confirmTitle: 'Edit IAM User?',
          confirmText: 'If you are sure to edit IAM user, please click the Save button below.',
        },
      },
      pageDashboard: {
        resource: 'Resources(Usage data updates in about 1 minute.)',
        lastestAnnouncement: 'Explore announcement',
        basicUsage: 'Limit default base usage',
        shortcut: 'Hotkeys',
        documents: 'Documentation',
        resourceFields: {
          vm: 'Virtual Machine',
          enable: 'Enabled',
          disable: 'Disabled',
          cpu: 'CPU',
          ram: 'Memory',
          ramUnit: 'GB',
          disk: 'Volumes',
          snapshot: 'Snapshot',
          loadBalancing: 'Load Balancing',
        },
        announcement: {
          publishDate: 'Create Date：',
          closeDialog: 'Close Dialog',
        },
        basicUsageFields: {
          baseVm: 'VM',
          baseBandwidth: 'Bandwidth',
          baseCpu: 'CPU',
          baseMemory: 'Memory',
          baseVolume: 'Volume',
          baseVpc: 'VPC',
          baseIp: 'Public IP',
        },
        unit: {
          BASE_SPEC_UNIT_SET: 'sets',
          BASE_SPEC_UNIT_CORE: 'core',
          BASE_SPEC_UNIT_MB: 'MB',
          BASE_SPEC_UNIT_MBPS: 'Mbps',
          BASE_SPEC_UNIT_GB: 'GB',
          BASE_SPEC_UNIT_PCS: 'pcs',
        },
        additionalInfo:'Use "Contact Chief Service" to adjust usage.'
      },
      pageVMSetting: {
        actions: {
          boot: 'Start',
          shutdown: 'Stop',
          poweroff: 'Terminate',
          adjustSpecification: 'Adjustment specifications',
          reset: 'Reboot',
          destroy: 'Delete',
          createVM: 'Launch Virtual Machine',
          instanceId: 'VM ID',
          confirmBootTitle: 'Start Virtual Machine?',
          confirmBootText: 'If you are sure to start the above Virtual Machine, please click the Save button below.',
          confirmShutdownTitle: 'Stop Virtual Machine?',
          confirmShutdownText: 'If you are sure to stop the above Virtual Machine, please click the Save button below.',
          confirmPoweroffTitle: 'Terminate Virtual Machine?',
          confirmPoweroffText: 'If you are sure to Terminate the above Virtual Machine, please click the Save button below.',
          confirmResetTitle: 'Reboot Virtual Machine?',
          confirmResetText: 'If you are sure to reboot the above Virtual Machine, please click the Save button below.',
          confirmDestroyTitle: 'Delete Virtual Machine？',
          confirmDestroyText: 'If you are sure to delete the above Virtual Machine, please click the Save button below.',
          adjustSpecificationTitle: 'Adjust Virtual Machine Specifications「{{uuid}}」',
          submit: 'Save',
          cancel: 'Cancel',
        },
        dataFields: {
          action: 'Actions',
          templateOSName: 'Operating System',
          uuid: 'VM ID',
          specifications: 'specifications',
          status: 'System state',
          privateIP: 'Private IP',
          publicIP: 'Public IP',
          lastShutdownTime: 'Last switch time',
          /** format */
          cpuCoresUnit: 'Core',
          ramSizeUnit: 'GB',
          statusEnum: {
            0: 'stopped',
            1: 'running',
            2: 'stopping',
            3: 'starting',
            4: 'launching',
            5: 'editing',
            6: 'recovering',
            7: 'error',
          },
        },
        detail: {
          detailInfo: 'Info',
          security: 'Security',
          web: 'Network',
          storage: 'Storage',
          monitor: 'Monitor',
          tag: 'Tags',
        },
        detailInfo: {
          instanceSummary: 'Virtual Machine Summary',
          uuid: 'VM ID',
          cpuCores: 'CPU Qty',
          templateUUID: 'CMI ID',
          publicIP: 'Public IPv4 address',
          privateIP: 'Private IPv4 address',
          ramSize: 'Memory Size',
          lastBootTime: 'Last start time',
          alreadyBoot: '（Running：{{day}} Day {{hour}} Hours {{min}} minutes）',
          hour: 'Hours',
          day: 'days',
          status: 'Virtual Machine state',
          templateOSType: 'Operating System',
          templateOSName: 'Platform Version',
        },
        detailSecurity: {
          title: 'Firewall Policies',
          dataFields: {
            netUuid: 'VPC',
            firewallUuid: 'FW ID',
            fwRuleUuid: 'Policy ID',
            fwrDirection: 'IN / OUT',
            fwrDirectionEnum: {
              1: 'Inbound',
              2: 'Outbound',
            },
            fwrIpVer: 'IPv4 / IPv6',
            fwrIpVerEnum: {
              1: 'IPv4',
              2: 'IPv6',
            },
            fwrType: 'Type',
            fwrTypeEnum: {
              0: 'ALL',
              1: 'TCP',
              2: 'UDP',
              3: 'ICMP',
            },
            fwrPort: 'Port',
            cidrDest: 'IN: source (white list) OUT: destination (black list)',
            fwrOperate: 'operation',
            fwrOperateEnum: {
              0: 'Allow',
              1: 'Deny',
            },
            remark: 'description',
          },
        },
        detailWeb: {
          title: 'Network Details',
          addVni: 'Add NIC',
          deleteVni: 'Delete NIC',
          publicIp: 'Public IPv4 address',
          privateIpv6: 'IPv6 address',
          privateIpv4: 'Private IPv4 address',
          vpcUuid: 'VPC ID',
          vniUuid: 'VNI ID',
          confirmDeleteVniTitle: 'Delete NIC?',
          confirmDeleteVniText1: 'Confirm delete this NIC?',
          confirmDeleteVniText2: 'Please click confirm button below.',
          ip: 'IP',
          vpc: 'VPC',
          vni: 'VNI',
        },
        detailAddVNI: {
          title: 'Add VNI',
          vpcId: 'VPC',
          fwId: 'Firewall Rule',
          create: 'Create',
          back: 'Back',
          confirmTitle: 'Add NIC?',
          confirmText1: 'Due to differences in operating systems, after adding a network card you may need to configure it yourself in the operating system, for example by enabling the network card, enabling DHCP or specifying the default gateway.',
          confirmText2: 'Confirm add this NIC?',
          confirmText3: 'Please click confirm button below.',
        },
        detailStorage: {
          rootDiskInfo: 'Root Device Details',
          rootDiskName: 'Root Device Name',
          dataDiskInfo: 'block storage device',
          dataFields: {
            diskUUID: 'Volume ID',
            diskName: 'Device Name',
            diskSize: 'Volume Sizes (GiB)',
            diskSizeUnit: ' GB',
            diskSpeed: 'Volume Type',
            diskSpeedEnum: {
              0: 'SSD',
              1: 'HDD',
            },
            vmUUID: 'Connected Virtual Machine',
          },
        },
      },
      pageCreateVM: {
        title: 'Launch Virtual Machine',
        core: 'Core',
        gb: 'GB',
        createVPC: 'Add VPC',
        createSecurityGroup: 'Add Firewall Policy',
        enable: 'Enabled',
        disable: 'Disabled',
        addDataDisk: 'Add Volume',
        diskType: 'Volume Type',
        rootDisk: 'Root Volume',
        disk: 'Volumes',
        destroy: 'Delete',
        formFields: {
          nameTag: 'Name Tags',
          templateOsName: 'Operating System',
          templateID: 'Operating System version',
          cpuCore: 'vCPU：',
          cpuCoreNote: '2-64 core',
          cpuError: 'CPU數量必須是偶數',
          ramSize: 'Memory：',
          ramSizeNote: '4-256 GB Memory GB shall not be lower than the number of CPUs, and shall not be greater than 8 times the number of CPUs.',
          vpcID: 'VPC',
          vpcFirewallIDs: 'Firewall',
          isAutoAssignPublicIP: 'Auto assign Public IP',
          dataDisks: 'Set Save：',
          dataDisksNote: 'Default「Root Volume」 minimum required is 50GB.',
          dataDisksNote2: 'Volume size and type cannot be adjusted when restoring to a new VM.',
          osNote: 'Restoring to a new VM cannot adjust the Operating System and version.',
          improvedInfo: 'Advanced Information',
          hypervisorId: 'Platform',
          enableAutoRecover: 'Virtual Machine Auto-recovery',
          enableTerminationProtection: 'Terminate Protection',
          enableStopProtection: 'Stop Protection',
          enableEnum: {
            'Y': 'Enable',
            'N': 'Disable',
          },
          enableEnumNote: 'Each VM is configured with a free public IP. Please enable it if necessary. The VM cannot be removed or added after it is created.'
        },
        submit: 'Save',
        reset: 'Reset',
        confirmTitle: 'Add Virtual Machine?',
        confirmText: 'If you are sure to Add Virtual Machine, please click the Save button below.',
        note: '修改防火牆時無法建立虛擬機',
      },
      pageDiskList: {
        title: 'Volumes',
        actions: {
          connectDisk: 'Link Volume',
          adjustDisk: 'Adjust Volume',
          adjustDiskTitle: 'Adjust Volume「{{uuid}}」',
          adjustDiskLabel: 'Volume size / type：',
          adjustDiskNote: 'The capacity can only be increased. If you change to a different type, it will take 3~7+ days to process the job depending on the capacity. After the completion, a separate email notification will be sent.',
          connectDiskTitle: 'Link Volume「{{uuid}}」',
          connectVMLabel: 'Link Virtual Machine (only in Stop state)',
          dontConnectVM: 'Do not link Virtual Machine',
          confirmDestroyTitle: 'Delete Volume?',
          diskId: 'Volume ID',
          confirmDestroyText: 'If you are sure to delete the above Volume, please click the Confirm button below.',
          submit: 'Save',
          cancel: 'Cancel',
          createDisk: 'Add Volume',
          destroyDisk: 'Delete Volume',
          deleteDiskTitle: 'Delete volume 「{{uuid}}」?',
          deleteDiskNote1: 'Are you sure you want to delete it?',
          deleteDiskNote2: 'Please note: Data cannot be restored after deletion.',
          deleteDiskPasswordPlaceholder: 'Please enter the password to confirm that you want to delete the disk volume.',
        },
        dataFields: {
          uuid: 'Volume ID',
          diskSize: 'Volume Sizes',
          diskSizeUnit: 'GB',
          diskSpeed: 'Volume Type',
          diskSpeedEnum: {
            0: 'SSD',
            1: 'HDD',
          },
          vmStatus: 'Virtual Machine state',
          vmStatusEnum: {
            0: 'stopped',
            1: 'running',
            2: 'stopping',
            3: 'starting',
            4: 'launching',
            5: 'editing',
            6: 'error',
          },
          vmUuid: 'Connected Virtual Machine',
        },
      },
      pageCreateDisk: {
        title: 'Add Volume',
        formFields: {
          diskName: 'Name Tag',
          diskSizeAndSpeed: 'Volume size / type',
          diskSizeUnit: 'GB',
          diskSpeedEnum: {
            0: 'SSD',
            1: 'HDD',
          },
          instanceId: 'Link to Virtual Machine (only in Stop state)',
          dontConnectDisk: 'Do not link Virtual Machine',
        },
        submit: 'Save',
        cancel: 'Cancel',
        confirmTitle: 'Add Volume?',
        confirmText: 'If you are sure to Add Volume, please click the Save button below.',
      },
      pageSnapshot: {
        title: 'Snapshots',
        actions: {
          createSnapshot: 'Add Snapshot',
          destroySnapshot: 'Delete Snapshot',
          restoreToVM: 'Restore to VM',
          createToNewVM: 'Add to new VM',
          confirmDestroyTitle: 'Delete Snapshot「{{name}}」?',
          confirmDestroyText1: 'Are you sure you want to delete {{name}}?',
          confirmDestroyText2: 'Please note: the data cannot be recovered after deletion!',
          confirmRestoreTitle: 'Restore Snapshot「{{name}}」to VM ID「{{vm}}」?',
          confirmRestoreText1: 'Are you sure you want to restore Snapshot {{name}} to {{vm}}?',
          confirmRestoreText2: 'Please note: Existing data will be overwritten after restoration, it is recommended to perform a Snapshot before restoration to avoid loss of important data!',
        },
        dataFields: {
          uuid: 'Snapshot ID',
          snapshotSizes: 'Sizes',
          vmUuid: 'VM ID',
          diskQty: 'Volume Qty',
          policyUuid: 'Policy ID',
          status: 'Snapshot state',
          statusEnum: {
            0: 'process',
            1: 'completed',
            2: 'restoring',
            6: 'Delete',
          },
          createDate: 'Create time',
        },
      },
      pageCreateSnapshot: {
        title: 'Add Snapshot',
        submit: 'Save',
        cancel: 'Cancel',
        confirmTitle: 'Add Snapshot?',
        confirmText: 'If you are sure to add Snapshot, please click the Save button below.',
        formFields: {
          instanceId: 'VM ID',
          disks: 'connected volumes',
          diskID: 'Volume ID',
          diskName: 'Device Name',
          diskSize: 'Volume Sizes(GiB)',
          diskSpeed: 'Volume Type',
          name: 'Name Tag',
        },
      },
      pageCreateSnapshotToNewVM: {
        title: 'Add to new VM',
        submit: 'Save',
        cancel: 'Cancel',
        confirmTitle: 'Add snapshot to new VM?',
        confirmText: 'If you are sure you want to add a snapshot to the new VM, click the Save button below.',
        formFields: {
          name: 'Name Tag',
        },
      },
      pageSnapshotRule: {
        title: 'Snapshot Policies',
        actions: {
          editSnapshotRule: 'Edit Snapshot Policy',
          destroySnapshotRule: 'Delete Snapshot Policy',
          confirmDestroyTitle: 'Delete snapshot policy "{{uuid}}"?',
          confirmDestroyText: 'Are you sure you want to delete snapshot policy {{uuid}}?',
          createSnapshotRule: 'Add Snapshot Policy',
        },
        dataFields: {
          uuid: 'Policy ID',
          policyName: 'Name',
          vmUuid: 'VM ID',
          vQty: 'Volumn Qty',
          createDate: 'Create Date',
        },
      },
      pageUpsertSnapshotRule: {
        createSnapshotRule: 'Add Snapshot Policy',
        editSnapshotRule: 'Edit Snapshot Policy',
        submit: 'Save',
        cancel: 'Cancel',
        formFields: {
          instanceId: 'VM-ID',
          vmUuid: 'VM-ID',
          instanceIdPlaceholder: 'please select a VM',
          policyName: 'Snapshot Policy name',
          policyCycle: 'Schedule',
          policyCycleEnum: {
            '0': 'half daily',
            '1': 'daily',
            '2': 'weekly',
          },
          cycleWeekEnum: {
            '1': 'Monday',
            '2': 'Tuesday',
            '3': 'Wednesday',
            '4': 'Thurday',
            '5': 'Friday',
            '6': 'Saturday',
            '7': 'Sunday',
          },
          qtyRule: 'snapshots to retain',
          qtyLimit1: 'how many copies to retain?',
          qtyLimit2: 'pcs',
        },
      },
      pageOrderHistory: {
        title: 'Order History List',
        contract: 'Current Contract',
        confirm: 'Confirm',
        reserve: 'Reservation Contract',
        records: 'Contract History',
        recordsNote: '(Only contracts that have taken effect are included, excluding reservation contracts.)',
        dataFields: {
          orderId: 'Contract Number',
          month: 'Contract Period',
          monthText: '{{n}} months',
          beginDate: 'Contract Effective Date',
          expireData: 'Contract Expiration Date',
          commit: 'Commit Amount',
          commitText: '{{n}} GB',
          autoExtend: 'Auto-renewal',
          autoExtendEnum: {
            'Y': 'Yes',
            'N': 'No',
          },
          modifyDate: 'Adjusted Date',
        },
      },
      pagePurchaseCCIS: {
        title: 'Contract Adjustment',
        note1: '1. The set capacity will be adjusted when the contract comes into effect.',
        note2: '2. The annual contract will be automatically renewed when the time is up. If you need to cancel the contract, please cancel it when it is about to expire. For orders that have been automatically renewed, please contact customer service if you need to cancel the contract.',
        note3: '3. If the above does not meet your needs, please contact customer service through the "I want to report for repair" function and enter your requirements in the obstacle message field.',
        note4: '4. The maximum capacity of each main account is 20TB. (If the total commit volume during the contract period exceeds 20TB, please contact customer service through the "I want to report for repair" function.)',
        contact: 'Contact Customer Service',
        submit: 'Submit',
        cancel: 'Cancel',
        successfulMessage: '購買成功！',
        formFields: {
          resourceItemId: 'Contract Period',
          blockSize: 'Capacity:',
          blockSizeNote: 'Current capacity is 1GB， Minimum capacity is 1000GB，Unit spacing: 100GB',
          blockSizeUnit: 'GB',
          autoExtend: 'Auto-renewal',
        },
      },
      pageUsageReport: {
        title: 'Usage Report',
        sizeTitle: 'Total Used Space',
        sizeNote: 'Unit：MB',
        itemTitle: 'Total Object',
        itemNote: 'Total number of folders and files in all buckets',
      },
      pageVNI: {
        title: 'VNIs',
        actions: {
          adjustNetSegment: 'Adjust network segment',
          adjustNetSegmentTitle: 'Adjust network segment ({{uuid}})',
          noFirewallNotify: 'The VPC is not associated with a firewall. Please bind it before proceeding with the VNI migration.',
        },
        dataFields: {
          vniUuid: 'VNI ID',
          vmUuid: 'VM ID',
          fwUuid: 'FW ID',
          vpcUuid: 'VPC ID',
          cidrIpv4: 'VNI NETWORK',
          publicIp: 'Public IP',
          privateIpv4: 'Private IP',
        },
      },
      pageFirewall: {
        title: 'Firewall Policies',
        actions: {
          createFirewall: 'Add Firewall Policy',
          editFirewall: 'Edit Firewall Policy',
          destroyFirewall: 'Delete Firewall Policy',
          confirmDestroyTitle: '刪除防火牆規則？',
          confirmDestroyText1: '確認您要「刪除防火牆規則」，而且無法連接到任何資源？',
          confirmDestroyText2: '要永久刪除 {{firewallId}} 嗎？無法復原此動作。',
          alertDestroyTitle: 'Delete Firewall Policy must not be associated with any Virtual Machine.',
          alertDestroyText1: 'To 「Delete Firewall Policy」must not be associated with any Virtual Machine,',
          alertDestroyText2: 'Please unassociate the Virtual Machine from the Firewall Policy to be Deleted before performing the Delete.',
          note: 'Status cannot be edited except [Error occurred、editable]',
        },
        dataFields: {
          firewallUuid: 'FW ID',
          fwCount: 'Policy count',
          vpcName: 'VPC',
          vms: 'Associated Virtual Machine',
          status: 'Status',
          statusEnum: {
            '-1': 'Error occurred. Please recheck the rules and send again, or seek customer service assistance',
            '1': 'Using it to create VM Now',
            '5': 'Updating',
            '6': 'Deleting',
            '7': 'Editable',
          },
        },
      },
      pageUpsertFirewall: {
        contact: 'Contact Chief Service',
        submit: 'Save',
        cancel: 'Cancel',
        remove: 'Delete',
        addRule: 'Add Policy',
        portHint: 'Please note: You can only enter one Port number or Any at a time for the port range. If you need a range (ex. 3000-4000), please contact our customer service staff!',
        formFields: {
          firewallName: 'Firewall Policy name',
          ruleId: 'Policy ID',
          fwrDirection: 'IN / OUT',
          fwrIpVer: 'IPv4 / IPv6',
          fwrType: 'Type',
          fwrPort: 'Port',
          fwrPortPlaceholder: 'Please enter a port range',
          cidrDest: 'CIDR',
          cidrDestIn: 'IN: source (white list)',
          cidrDestOut: 'OUT: destination (blacklist)',
          fwrOperate: 'Operation',
          remark: 'description',
          remarkPlaceholder0: 'please enter a description',
          remarkPlaceholder1: 'deny all access by default',
          remarkPlaceholder2: 'allow all access by default',
        },
        errors: {
          notEmpty: '{{0}} cannot be empty!',
          port0: 'When the policy type is ALL, the port must be Any',
          port1: 'When the policy type is TCP, the port must be 1-65535 and may use single values, comma-separated values, or ranges',
          port2: 'When the policy type is UDP, the port must be 1-65535 and may use single values, comma-separated values, or ranges',
          port3: 'When the policy type is ICMP, the port must be -1',
        },
        pageCreate: {
          title: 'Add Firewall Policy',
          confirmTitle: 'Add Firewall Policy?',
          confirmText: 'If you are sure to add Firewall Policy, please click the Save button below.',
        },
        pageEdit: {
          title: 'Edit Firewall Policy',
          confirmTitle: 'Edit Firewall Policy？',
          confirmText: 'If you are sure to edit Firewall Policy, please click the Save button below.',
        },
      },
      pageBalancer: {
        title: 'Load Balancers',
        yes: 'Yes',
        no: 'No',
        actions: {
          createBalancer: 'Add Load Balancing',
          editBalancer: 'Edit Load Balancing',
          destroyBalancer: 'Delete Load Balancing',
          confirmDestroyTitle: 'Delete Load Balancing?',
          confirmDestroyText1: 'Are you sure you want to「Delete Load Balancing」and can not connect to any resources?',
          confirmDestroyText2: 'Do you want to permanently delete {{name}}? Unable to undo this action.',
        },
        dataFields: {
          lbType: 'Type',
          lbName: 'Name',
          lbProtocol: 'Protocol',
          lbPort: 'Port',
          lbUrl: 'URL',
          lbCertificate: 'Certificate',
          vpcUuid: 'VPC ID',
          vmUuid: 'VM ID',
          lbHealthCheck: 'Health Check',
          lbXforwardedfor: 'X-forwarded-for',
        },
      },
      pageUpsertBalancer: {
        submit: 'Save',
        cancel: 'Cancel',
        yes: 'Yes',
        no: 'No',
        uploadedFile: 'File uploaded',
        errors: {
          lbPort: 'Port must be a number from 1 to 65535',
        },
        formFields: {
          lbType: 'Type',
          lbName: 'Name',
          lbProtocol: 'Protocol',
          lbPort: 'Port',
          lbUrl: 'URL',
          lbCertificate: 'Certificate(if HTTPS)',
          vpcId: 'VPC',
          lbHealthCheck: 'Health Check',
          lbXforwardedfor: 'X-forwarded-for',
          vmId: 'Target VM ID',
        },
        pageCreate: {
          title: 'Add Load Balancing',
          confirmTitle: 'Add Load Balancing?',
          confirmText: 'If you are sure to add Load Balancing, please click the Save button below.',
        },
        pageEdit: {
          title: 'Edit Load Balancing',
          confirmTitle: 'Edit Load Balancing?',
          confirmText: 'If you are sure to edit Load Balancing, please click the Save button below.',
        },
      },
      pageBucket: {
        title: 'Bucket List',
        actions: {
          createBucket: 'LAUNCH BUCKET',
          emptyBucket: '清空儲存桶',
          deleteBucket: '刪除儲存桶',
        },
        dataFields: {
          name: 'Bucket Name',
          namePlaceholder: '只能英數字',
          isPublic: 'Public Access',
          isPublicEnum: {
            public: 'Public',
            private: 'Private',
          },
          size: 'Current Usage',
          createDate: 'Create Date',
        },
        emptyDialog: {
          title: '清空儲存桶「{{bucketName}}」所有物件嗎？',
          text1: '清空儲存桶-永久刪除儲存桶 {{bucketName}} 中的所有物件？',
          text2: '請注意：',
          text3: '清空儲存桶會刪除儲存桶中的所有物件，而且無法復原！',
          text4: '在清空儲存桶動作進行期間，新增至儲存桶的物件可能會被刪除。',
          text5: '若確認要清空，請在下方文字框中輸入登入密碼：',
          pwPlaceholder: '請輸入密碼確認要清空儲存桶',
        },
        deleteDialog: {
          title: '確認刪除儲存桶「{{bucketName}}」嗎？',
          text1: '確認永久刪除儲存桶 {{bucketName}} ？',
          text2: '請注意：',
          text3: '刪除儲存桶無法復原！',
          text4: '儲存桶名稱是唯一的，如果刪除此儲存桶，則可能為他人使用。',
          text5: '若確認要刪除，請在下方文字框中輸入登入密碼：',
          pwPlaceholder: '請輸入密碼確認要刪除儲存桶',
        },
        deleteDeniedDialog: {
          title: '儲存桶「{{bucketName}}」無法刪除！',
          text1: '儲存桶 {{bucketName}} 有資料無法刪除，只能刪除已清空的儲存桶！',
          text2: '請注意：',
          text3: '若要刪除儲存桶，必須將儲存桶內的所有物件清空。',
          text4: '若要刪除儲存桶中的所有物件，請先使用清空儲存桶。',
        },
        objectCreateDialog: {
          title: '新增資料夾',
          formFields: {
            name: '資料夾名稱',
            namePlaceholder: '資料夾名稱只能英數字，不可包含/',
          },
        },
        objectDeleteDialog: {
          title: '確認刪除此物件？',
          text1: '刪除的指定物件無法復原。',
          text2: '系統會刪除指定資料夾內的所有物件。',
          text3: '在刪除物件動作進行期間，新增至這些資料夾內的物件可能會被刪除。',
        },
        objectCopyMoveDialog: {
          copyTitle: '複製物件',
          moveTitle: '移動物件',
          notify: 'It\'s not allow to copy or move a folder into the same path or sub-folder.',
          formFields: {
            bucketName: '目的地儲存桶名稱',
            prefix: '目的地資料夾',
          },
        },
        objectRenameDialog: {
          title: '重新命名指定物件',
          formFields: {
            name: '請輸入更改的名稱',
          },
        },
        objectUrlDialog: {
          title: '查看連結點',
          text: '查看「{{name}}」連結點：',
        },
        objectPresignedUrlDialog: {
          title: '與預先簽章的URL共用',
          formFields: {
            name: '連結名稱',
            expiration: '有效時間',
            expirationUnit: '(單位：分)',
            url: '分享連結',
          },
        },
        lifecycleUpsertDialog: {
          createTitle: '新增物件週期',
          updateTitle: '修改物件週期',
          formFields: {
            tagKey: 'Tag - Key',
            tagValue: 'Tag - Value',
            prefix: 'Prefix',
            prefixPlaceholder: '請輸入前綴字元',
            expiration: 'Expiration',
            expirationPlaceholder: '請輸入正整數並大於0',
            expirationUnit: '天',
            enabled: 'Enabled',
            enabledEnum: {
              enabled: '啟用',
              disabled: '關閉',
            },
          },
        },
        lifecycleDeleteDialog: {
          title: '刪除物件週期？',
          text: '確定您要刪除週期，而且無法復原此動作。',
        },
        detail: {
          objectActions: '物件操作',
          bucketInfo: '查看資訊',
          permission: '設定權限',
          bucketUsage: '查看用量',
          objectLifecycle: '物件週期',
          apiSecretKey: 'api密鑰',
        },
        detailObjects: {
          title: '物件操作列表',
          actions: {
            createFolder: '新增資料夾',
            uploadFile: '上傳檔案',
            delete: '刪除',
            copy: '複製',
            move: '移動',
            rename: '重新命名',
            url: '查看存取點',
            presignedUrl: '預先簽章URL共用',
          },
          dataFields: {
            name: 'Name',
            backToUpperFolder: '回上一層',
            size: 'Sizes',
            type: 'Type',
            lastModified: 'Last Modified',
          },
        },
        detailLifecycle: {
          title: '物件週期列表',
          actions: {
            create: '新增物件週期',
            update: '修改物件週期',
            delete: '刪除物件週期',
          },
          dataFields: {
            tag: 'Tag',
            prefix: 'Prefix',
            expiration: 'Expiration',
            enabled: 'Enabled',
            enabledEnum: {
              enabled: '啟用',
              disabled: '關閉',
            },
          },
        },
        detailSecretKey: {
          title: '查看API密鑰',
          name: 'Name',
          accessKey: 'Access Key ID',
          secretAccessKey: 'Secret Access Key',
        },
      },
      pageVPCNet: {
        title: 'Your VPCs',
        actions: {
          editVPCNet: 'Edit VPC',
          editRouteRule: 'Edit Route Table',
          destroyVPCNet: 'Delete VPC',
          confirmDestroyTitle: 'Delete VPC？',
          confirmDestroyText1: 'Are you sure you want to「Delete VPC」and can not connect to any resources?',
          confirmDestroyText2: 'Do you want to permanently delete {{netUuid}}? This action cannot be undone.',
          createVPCNet: 'Add VPC',
        },
        dataFields: {
          netName: 'VPC Name',
          netUuid: 'VPC ID',
          status: 'VPC state',
          statusEnum: {
              0: 'processing',
              1: 'avaiable',
              6: 'Deleting',
          },
          routeLevel: 'Route Level',
          routeLevelEnum: {
            1: 'Platinum',
            2: 'Professional',
          },
          chargeMode: 'Charge Mode',
          chargeModeEnum: {
            1: 'Fixed Mode',
            2: 'Ninety-five Mode',
            3: 'Total quantity Mode',
          },
          bandwidthLimit: 'Bandwidth Limit(M/bps)',
          cidrIpv4: 'IPv4 CIDR',
          cidrIpv6: 'IPv6 CIDR',
          cidrIpv6Enum: {
            'none': 'None',
            '-1': 'Allocation ',
          },
          vmNum: 'Number of associated VMs',
        },
      },
      pageCreateVPCNet: {
        title: 'Add VPC',
        formFields: {
          sourceTypeLabel1: 'resources to add',
          sourceTypeLabel2: 'Only add VPC resources or VPC, etc.',
          sourceTypeEnum: {
            1: 'VPC only',
          },
          vpcNameLabel1: 'Name Tag',
          vpcNameLabel2: 'Add tag, where the index key is \'Name\' and the value is the value you specify.',
          vpcNamePlaceholder: 'Example: formal environment',
          cidrIpv4Label1: 'IPv4 CIDR',
          cidrIpv4Label2: 'Enter the IPv4 CIDR manually.',
          cidrIpv4Placeholder: '10.0.0.0/24',
          cidrIpv6Label1: 'IPv6 CIDR',
          cidrIpv6Label2: 'Please select an IPv6 CIDR.',
          cidrIpv6Enum: {
            'null': 'No IPv6 CIDR',
            '-1': 'IPv6 CIDR provided by the Chief Telecom',
          },
          bandwidthLimit: 'Bandwidth Limit(M/bps)',
          bandwidthLimitPlaceholder: '限 1 ～ 500',
          routeLevel: 'Route Level',
          routeLevelEnum: {
            1: 'Platinum',
            2: 'Professional',
          },
          routeLevelMemo: 'Platinum routing level is China’s high-quality routing service, and the billing unit price is higher than that of professional routing level. Please choose carefully. If you need other preferential plans, please contact us through the "I want to report repair" function, and a dedicated person will contact you.',
          chargeMode: 'Charge Mode',
          chargeModeEnum: {
            1: 'Fixed Mode',
            2: 'Ninety-five Mode',
            3: 'Total quantity Mode',
          },
        },
        needBeCidrIpv4: 'Need be legal IPv4 CIDR!',
        submit: 'Save',
        cancel: 'Cancel',
        confirmTitle: 'Add VPC?',
        confirmText: 'If you are sure to add VPC, please click the Save button below.',
      },
      pageEditVPCNet: {
        title: 'Edit VPC',
        formFields: {
          netNameLabel: 'Name Tag',
          netNamePlaceholder: 'Add tag, where the index key is \'Name\' and the value is the value you specify.',
          chargeMode: 'Charge Mode',
          chargeModeEnum: {
            1: 'Fixed Mode',
            2: 'Ninety-five Mode',
            3: 'Total quantity Mode',
          },
          bandwidthLimit: 'Bandwidth Limit',
          bandwidthLimitPlaceholder: '限 1 ～ 500',
        },
        submit: 'Save',
        cancel: 'Cancel',
        confirmTitle: 'Edit VPC?',
        confirmText: 'If you are sure to edit VPC, please click the Save button below.',
      },
      pageEditNetRoute: {
        title: 'Edit Route Table',
        formFields: {
          cidrDest: 'destination',
          targetTypeEnum: {
            0: 'Manual',
            1: 'Local',
            2: 'Default',
            3: 'VPC',
          },
          targetType: 'Target',
          pleaseSelectVPC: 'Please select a VPC.',
          target: 'Target',
          destroy: 'Delete',
        },
        addRoute: 'Add Route Table',
        submit: 'Save',
        cancel: 'Cancel',
        confirmTitle: 'Edit Route Table?',
        confirmText: 'If you are sure to save the currently edited Route Table, please click the Save button below.',
      },
      pageCCXList: {
        title: 'Chief Cloud eXchanges',
        actions: {
          createCCX: 'Add Chief Cloud eXchange',
        },
        dataFields: {
          clientNumber: 'Client Number',
          ccxType: 'Platofrm',
          ccxTypeEnum: {
            1: 'AWS',
            2: 'GCP',
            3: 'Azure',
            4: 'CCX',
          },
          pairKey: 'AWS ID / Service Key / Pair Key / CCX ID',
          createDate: 'Create Date',
          status: 'state',
          statusEnum: {
            0: 'available',
            1: 'ordering',
            2: 'done',
          },
          vpcName: 'VPC',
        },
      },
      pageCreateCCX: {
        title: 'Add Chief Cloud eXchange',
        formFields: {
          ccxType: 'Public cloud platform',
          ccxTypeEnum: {
            1: 'AWS',
            2: 'GCP',
            3: 'Azure',
            4: 'CCX',
          },
          pairKeyLabelEnum: {
            1: 'AWS ID',
            2: 'Pair Key',
            3: 'Service Key',
            4: 'CCX ID',
          },
          vpcId: 'VPC',
        },
        submit: 'Save',
        cancel: 'Cancel',
        confirmTitle: 'Add Chief Cloud eXchange?',
        confirmText: 'If you are sure to add Chief Cloud eXchange, please click the Save button below.',
      },
      pageSingleVM: {
        noVmData: '查無虛擬機資料！',
        title1: 'Per VM',
        title2: 'Usage Data',
        filterItem: 'Metrics Select',
        itemEnum: {
          'CPU usage%': 'CPU usage%',
          'Memory usage GB/MB': 'Memory usage GB/MB',
          'Status': 'Status',
          'Volume Read': 'Volume Read',
          'Volume Write': 'Volume Write',
          'Network in': 'Network in',
          'Network out': 'Network out',
        },
        filterVM: 'VM',
        pleaseSelectVM: 'VM Select',
        query: 'Search',
        time15min: '15 minutes',
        time1hour: '1 hour',
        time12hour: '12 hours',
        time1day: '1 day',
        on: 'On',
        off: 'Off',
      },
      pageTotalUsage: {
        title: 'Usage Metrics',
        filterItem: 'Metrics Select',
        query: 'Search',
        time15min: '15 minutes',
        time1hour: '1 hour',
        time12hour: '12 hours',
        time1day: '1 day',
      },
      pageAlarm: {
        title: 'Alarm List',
        actions: {
          createAlarm: 'ADD ALARM',
          manualAlarm: '手動告警',
          editAlarm: '修改告警',
          destroyAlarm: '刪除告警',
          confirmManualTitle: '手動告警',
          confirmManualText1: '確認您要手動告警「{{id}}」？',
          confirmManualText2: '手動告警會立即將狀態改成警示中，並發MAIL給相關人員。',
          confirmDestroyTitle: '刪除本筆告警',
          confirmDestroyText1: '確認您要刪除告警「{{id}}」？',
          confirmDestroyText2: '要永久刪除「{{id}}」嗎？無法復原此動作。',
          submit: 'Submit',
          cancel: 'Cancel',
        },
        dataFields: {
          alarmId: 'Alarm ID',
          item: 'Metrics Name',
          uuid: 'VM ID',
          critical: 'Critical Condition',
          displayCritical: '{{point}} {{number}}',
          continuance: 'Continuance',
          displayContinuance: '{{n}} 個資料點',
          coolDownTime: 'Cool Down Time',
          displayCoolDownTime: '{{n}} minute',
          status: 'Status',
          statusEnum: {
            0: '正常',
            1: '警示中',
            2: '資料不足',
          },
          lAlarmTime: 'Last Alarm Time',
        },
      },
      pageUpsertAlarm: {
        create: 'Add',
        edit: 'Edit',
        title: '{{action}} Alarm',
        formFields: {
          itemId: 'Metrics Select',
          instanceId: 'VM Select',
          critical: 'Set Critical Point',
          criticalPoint: 'Select Critical Point Condition',
          criticalPointEnum: {
            '>': '大於(>)',
            '>=': '大於等於(>=)',
            '<': '小於(<)',
            '<=': '小於等於(<=)',
          },
          criticalNumber: 'Please enter the value of the critical point. Only positive integers can be entered.',
          otherCondition: 'Other Trigger Condition',
          continuance: 'Please enter duration(Unit: XX data points). Only positive integers can be entered.',
          coolDownTime: 'Please enter the post-alarm cooling time (unit: minutes). Only positive integers can be entered.',
          emails: 'Notification Object',
          emailsNote: 'Notification objects: Email list of MAIL as the main account or IAM User login account (maximum amount is 10)',
          destroy: 'Delete',
          addEmail: 'Add Notification Object',
        },
        cancel: 'Cancel',
        submit: 'Submit',
        confirmTitle: '{{action}} Alarm？',
        confirmText: '若確定要{{action}}告警，請點擊下方確認按鈕。',
      },
      pageExCloud: {
        title: 'Public Cloud Certificate List',
        actions: {
          destroy: 'DELETE CERTIFICATE',
          create: 'ADD CERTIFICATE',
          confirmDestroyTitle: 'DELETE CERTIFICATE',
          confirmDestroyText1: '確認您要刪除「{{type}}」憑證？',
          confirmDestroyText2: '此動作確認後無法復原。',
        },
        dataFields: {
          publicCloudType: 'Platform',
          publicCloudTypeEnum: {
            1: 'AWS',
            2: 'GCP',
            3: 'Azure',
          },
          id: 'Access Key ID / API Key / Application ID',
          secret: 'Secret Access Key / Application PWD',
          directoryId: 'Directory ID',
          subscriptionId: 'Subscription ID',
          createDate: 'Create Time',
        },
        detail: {
          awsTitle: 'AWS虛擬機列表',
          gcpTitle: 'GCP虛擬機列表',
          azureTitle: 'Azure虛擬機列表',
          region: '區域',
          displayALL: '顯示全部',
          awsDataFields: {
            region: '區域',
            vmName: 'VM名稱',
            vmUuid: 'VM ID',
            vmStatus: 'VM狀態',
            vmCombo: 'VM規格',
            vmPublicIp: 'VM Public IP',
            vmPrivateIp: 'VM Private IP',
            vmOpenTime: 'VM開機時間(UTC)',
            subscriptionAccount: '訂用帳戶',
            resourceGroup: '資源群組',
            vmOs: '作業系統',
            vmSizes: '大小',
            vmDisk: '磁碟',
            vmVni: 'VM所屬網段之ID',
          },
          gcpDataFields: {
            status: '狀態',
            name: '名稱',
            deletionProtection: 'Deletion Protection',
            zone: '區域',
            creationTime: 'Creation Time',
            machineType: 'Machine Type',
            preservedStateSize: 'Preserved state size',
            recommendations: 'Recommendations',
            inUseBy: 'In Use by',
            internalIp: 'Internal IP',
            externalIp: 'External IP',
          },
          azureDataFields: {
            vmName: '名稱',
            vmType: '類型',
            subscriptionAccount: '訂用帳戶',
            resourceGroup: '資源群組',
            region: '位置',
            vmStatus: '狀態',
            vmOs: '作業系統',
            vmSizes: '大小',
            vmPublicIp: '公用IP位址',
            vmDisk: '磁碟',
          },
        },
      },
      pageCreateExCloud: {
        title: 'Add Certificate',
        placeholderPrefix: '請輸入該公有雲申請之{{fieldName}}',
        formFields: {
          publicCloudType: 'Public Cloud Platform',
          publicCloudTypeEnum: {
            1: 'AWS',
            2: 'GCP',
            3: 'Azure',
          },
          accessKeyId: 'Access Key ID',
          secretAccessKey: 'Secret Access Key',
          apiKey: 'API Key',
          directoryId: 'Directory ID',
          applicationId: 'Application ID',
          subscriptionId: 'Subscription ID',
          applicationPwd: 'Application PWD',
        },
        submit: 'Submit',
        cancel: 'Cancel',
        confirmTitle: 'Add Certificate？',
        confirmText: '若確定要憑證，請點擊下方確認按鈕。',
      },
      pageValuation: {
        title: 'Monthly Charge Valuation',
        titleNote: 'The total monthly cost is estimated based on the resource usage of the previous day. When resources change frequently, there will be a large gap, and the actual amount is based on the bill.',
        totalCost: 'Monthly Charge Total Valuation',
        vmCost: 'Virtual Machine',
        ccisCost: 'CCIS',
        vmDetail: 'Virtual Machine Details of the previous day',
        ldate: 'Date',
        vms: 'Total Number of Virtual Machines',
        cpus:'Total CPU',
        rams: 'Total RAM',
        disks: 'Total Disk',
        bandwidth: 'Total Network Bandwith',
        images: 'Total Number of Images Charged',
        ccisDetail: 'CCIS Details of the Previous Day',
        commit:'Commit Amount',
        actual: 'Maximum Usage',
        overQty: 'Total excess (GB*1hour)',
        unit: {
          g: 'G',
          m: 'M',
          gb: 'GB',
        },
      },
      WorkInProgressText1: 'website is under construction',
      WorkInProgressText2: 'coming soon…',
    },
    /** form */
    form: {
      /** placeholder */
      pleaseInput: 'Please Input {{fieldName}}',
      pleaseUpload: 'Please Upload {{fieldName}}',
      /** multiple select */
      multipleSelectItems: '{{n}} items selected',
      /** captcha input */
      inputCaptcha: 'Enter the alphanumeric in lowercase.',
      changeAnother: 'Change',
      /** file upload input */
      errorFileType: 'Incorrect file format!',
      /** phone input */
      pleaseInputPhone3: 'ext.',
      /** file input */
      preview: 'preview',
      countries: {
        afghanistan: 'Afghanistan',
        albania: 'Albania',
        algeria: 'Algeria',
        americansamoa: 'American Samoa',
        andorra: 'Andorra',
        angola: 'Angola',
        anguilla: 'Anguilla',
        antarctica: 'Antarctica',
        antiguaandbarbuda: 'Antigua and Barbuda',
        argentina: 'Argentina',
        armenia: 'Armenia',
        aruba: 'Aruba',
        australia: 'Australia',
        austria: 'Austria',
        azerbaijan: 'Azerbaijan',
        bahamas: 'Bahamas',
        bahrain: 'Bahrain',
        bangladesh: 'Bangladesh',
        barbados: 'Barbados',
        belarus: 'Belarus',
        belgium: 'Belgium',
        belize: 'Belize',
        benin: 'Benin',
        bermuda: 'Bermuda',
        bhutan: 'Bhutan',
        bolivia: 'Bolivia',
        bosnia: 'Bosnia and Herzegovina',
        botswana: 'Botswana',
        brazil: 'Brazil',
        britishindianoceanterritory: 'British Indian Ocean Territory',
        britishvirginislands: 'British Virgin Islands',
        brunei: 'Brunei',
        bulgaria: 'Bulgaria',
        burkinafaso: 'Burkina Faso',
        burma: 'Myanmar',
        burundi: 'Burundi',
        cambodia: 'Cambodia',
        cameroon: 'Cameroon',
        canada: 'Canada',
        capeverde: 'Cape Verde',
        caymanislands: 'Cayman Islands',
        centralafricanrepublic: 'Central African Republic',
        chad: 'Chad',
        chile: 'Chile',
        china: 'China',
        christmasisland: 'Christmas Island',
        cocoskeelingislands: 'Cocos Islands',
        colombia: 'Colombia',
        comoros: 'Comoros',
        congo: 'Republic of the Congo',
        congodemocraticrepublic: 'Democratic Republic of the Congo',
        cookislands: 'Cook Islands',
        costarica: 'Costa Rica',
        croatia: 'Croatia',
        cuba: 'Cuba',
        curacao: 'Curacao',
        cyprus: 'Cyprus',
        czechrepublic: 'Czech Republic',
        denmark: 'Denmark',
        djibouti: 'Djibouti',
        dominica: 'Dominica',
        dominicanrepublic1: 'Dominican Republic',
        dominicanrepublic2: 'Dominican Republic',
        dominicanrepublic3: 'Dominican Republic',
        easttimor: 'East Timor',
        ecuador: 'Ecuador',
        egypt: 'Egypt',
        elsalvador: 'El Salvador',
        equatorialguinea: 'Equatorial Guinea',
        eritrea: 'Eritrea',
        estonia: 'Estonia',
        ethiopia: 'Ethiopia',
        falklands: 'Falkland Islands',
        faroeislands: 'Faroe Islands',
        fiji: 'Fiji',
        finland: 'Finland',
        france: 'France',
        frenchpolynesia: 'French Polynesia',
        gabon: 'Gabon',
        gambia: 'Gambia',
        georgia: 'Georgia',
        germany: 'Germany',
        ghana: 'Ghana',
        gibraltar: 'Gibraltar',
        greece: 'Greece',
        greenland: 'Greenland',
        grenada: 'Grenada',
        guam: 'Guam',
        guatemala: 'Guatemala',
        guernsey: 'Guernsey',
        guinea: 'Guinea',
        guineabissau: 'Guinea-Bissau',
        guyana: 'Guyana',
        haiti: 'Haiti',
        honduras: 'Honduras',
        hongkong: 'Hong Kong',
        hungary: 'Hungary',
        iceland: 'Iceland',
        india: 'India',
        indonesia: 'Indonesia',
        iran: 'Iran',
        iraq: 'Iraq',
        ireland: 'Ireland',
        isleofman: 'Isle of Man',
        israel: 'Israel',
        italy: 'Italy',
        ivorycoast: 'Ivory Coast',
        jamaica: 'Jamaica',
        japan: 'Japan',
        jersey: 'Jersey',
        jordan: 'Jordan',
        kazakhstan: 'Kazakhstan',
        kenya: 'Kenya',
        kiribati: 'Kiribati',
        kosovo: 'Kosovo',
        kuwait: 'Kuwait',
        kyrgyzstan: 'Kyrgyzstan',
        laos: 'Laos',
        latvia: 'Latvia',
        lebanon: 'Lebanon',
        lesotho: 'Lesotho',
        liberia: 'Liberia',
        libya: 'Libya',
        liechtenstein: 'Liechtenstein',
        lithuania: 'Lithuania',
        luxembourg: 'Luxembourg',
        macau: 'Macau',
        macedonia: 'Macedonia',
        madagascar: 'Madagascar',
        malawi: 'Malawi',
        malaysia: 'Malaysia',
        maldives: 'Maldives',
        mali: 'Mali',
        malta: 'Malta',
        marshallislands: 'Marshall Islands',
        mauritania: 'Mauritania',
        mauritius: 'Mauritius',
        mayotte: 'Mayotte',
        mexico: 'Mexico',
        micronesia: 'Micronesia',
        moldova: 'Moldova',
        monaco: 'Monaco',
        mongolia: 'Mongolia',
        montenegro: 'Montenegro',
        montserrat: 'Montserrat',
        morocco: 'Morocco',
        mozambique: 'Mozambique',
        namibia: 'Namibia',
        nauru: 'Nauru',
        nepal: 'Nepal',
        netherlands: 'Netherlands',
        netherlandsantilles: 'Netherlands Antilles',
        newcaledonia: 'New Caledonia',
        newzealand: 'New Zealand',
        nicaragua: 'Nicaragua',
        niger: 'Niger',
        nigeria: 'Nigeria',
        niue: 'Niue',
        northernmarianaislands: 'Northern Mariana Islands',
        northkorea: 'North Korea',
        norway: 'Norway',
        oman: 'Oman',
        pakistan: 'Pakistan',
        palau: 'Palau',
        palestine: 'Palestine',
        panama: 'Panama',
        papuanewguinea: 'Papua New Guinea',
        paraguay: 'Paraguay',
        peru: 'Peru',
        philippines: 'Philippines',
        pitcairnislands: 'Pitcairn',
        poland: 'Poland',
        portugal: 'Portugal',
        puertorico1: 'Puerto Rico',
        puertorico2: 'Puerto Rico',
        qatar: 'Qatar',
        reunion: 'Reunion',
        romania: 'Romania',
        russia: 'Russia',
        rwanda: 'Rwanda',
        saintbarthelemy: 'Saint Barthelemy',
        samoa: 'Samoa',
        sanmarino: 'San Marino',
        saotomeandprincipe: 'Sao Tome and Principe',
        saudiarabia: 'Saudi Arabia',
        senegal: 'Senegal',
        serbia: 'Serbia',
        seychelles: 'Seychelles',
        sierraleone: 'Sierra Leone',
        singapore: 'Singapore',
        sintmaarten: 'Sint Maarten',
        slovakia: 'Slovakia',
        slovenia: 'Slovenia',
        solomonislands: 'Solomon Islands',
        somalia: 'Somalia',
        southafrica: 'South Africa',
        southkorea: 'South Korea',
        southsudan: 'South Sudan',
        spain: 'Spain',
        srilanka: 'Sri Lanka',
        sthelena: 'Saint Helena',
        stkitts: 'Saint Kitts and Nevis',
        stlucia: 'Saint Lucia',
        stmartin: 'Saint Martin',
        stpierre: 'Saint Pierre and Miquelon',
        stvincent: 'Saint Vincent and the Grenadines',
        sudan: 'Sudan',
        suriname: 'Suriname',
        svalbard: 'Svalbard and Jan Mayen',
        swaziland: 'Swaziland',
        sweden: 'Sweden',
        switzerland: 'Switzerland',
        syria: 'Syria',
        taiwan: 'Taiwan',
        tajikistan: 'Tajikistan',
        tanzania: 'Tanzania',
        thailand: 'Thailand',
        togo: 'Togo',
        tokelau: 'Tokelau',
        tonga: 'Tonga',
        trinidadandtobago: 'Trinidad and Tobago',
        tunisia: 'Tunisia',
        turkey: 'Turkey',
        turkmenistan: 'Turkmenistan',
        turksandcaicos: 'Turks and Caicos Islands',
        tuvalu: 'Tuvalu',
        uae: 'United Arab Emirates',
        uganda: 'Uganda',
        uk: 'United Kingdom',
        ukraine: 'Ukraine',
        uruguay: 'Uruguay',
        usa: 'United States',
        uzbekistan: 'Uzbekistan',
        vanuatu: 'Vanuatu',
        vatican: 'Vatican',
        venezuela: 'Venezuela',
        vietnam: 'Vietnam',
        virginislands: 'U.S. Virgin Islands',
        wallisandfutuna: 'Wallis and Futuna',
        westernsahara: 'Western Sahara',
        yemen: 'Yemen',
        zambia: 'Zambia',
        zimbabwe: 'Zimbabwe',
      },
    },
    /** validation */
    validation: {
      notEmpty: 'Cannot be empty!',
      needBeFormat: 'Must be in {{format}} format!',
      needBePhone: 'Must be in phone format!',
      needBePersonId: 'It must be in the format of the National Identity Card Number of the Republic of China!',
      needBeCompanyId: 'It must be a unified numbering format for companies in the Republic of China!',
      needBePersonIdOrCompanyId: 'Must be in the ROC ID number or company uniform number format!',
      needBeHost: 'Must be in IPv4, IPv6 or domain format!',
      needBeSerialString: 'Must be a string consisting of English, numbers, dash or underline!',
      needBeInteger: 'Must be an integer!',
      needBeIntegerOrEmpty: 'Must be empty or an integer!',
      needBeNumberInRange: 'Must be a number from {{min}}~{{max}}!',
      needBeNumberGreaterThan: 'Must be a number greater than {{min}}!',
      hasMaxDecimal: '小數點後最多輸入{{max}}位數字！',
      hexStringInRange: 'Hexadecimal digits of {{min}}~{{max}}',
      needBeHexNumber: 'Must be a hexadecimal number!',
      needBeHexNumberStringInRange: 'Must be a string of hexadecimal digits from {{min}}~{{max}}!',
      hexNumberStringInRange: 'Hexadecimal string of {{min}}~{{max}}',
      needBeStringInRange: 'Must be a string with a length between {{min}}~{{max}}!',
      needBeStringExclude: 'Must be a string that does not contain 「{{character}}」!',
      needBeAlphaNumeric: 'Must be a string of English or numbers!',
      needBeChineseAlphaNumeric: 'Must be a string of Chinese or English or numbers!',
      needBeAccount: 'It must be a string composed of characters such as English or numbers or dot, @, underline, dash!',
      needBePassword: 'Must be 12~32 characters, including uppercase and lowercase English, numbers and special symbol characters!',
      needBeIpV4Range: 'Must be IPV4 (segment)!',
      needBeStringListSplitByCommaOrNewLine: 'Must be a list of items separated by commas or newlines!',
      needBeIntegerOrIntegerRangeStringListSplitByComma: 'Must be a string of integers or integer segments separated by commas or newlines, and each number (or segment) must be between {{min}} and {{max}}!',
      needBeS3Bucket: 'Must be 3~63 characters, including lowercase English、numbers or dash characters!',
      needBeS3Folder: 'Must be characters including uppercase and lowercase English or numbers!',
      startTimeCannotBeLaterThanEndTime: 'The start time cannot be later than the end time!',
      cantSelectSelf: 'You can\'t choose yourself!',
    },
    /** table */
    table: {
      totalItems: 'Total data items: {{items}}',
      configDialogTitle: 'setting form',
      rowsPerPage: 'Number of items displayed per page',
      infinityRowsPerPage: 'no page break',
      reOrderDescription: 'Drag a field to adjust the order of the fields',
      name: 'field name',
      width: 'width',
      hidden: 'hidden',
      saveConfigure: 'Save',
      cancel: 'Cancel',
      action: 'Actions'
    },
    /** notify */
    notify: {
      submitSuccess: 'Save Success!',
      createSuccess: 'Add Success!',
      updateSuccess: 'Edit Success!',
      deleteSuccess: 'Delete Success!',
      confirmDestroy: 'Are you sure you want to delete{type}「{{name}}」?',
      confirm: 'Save',
      cancel: 'Cancel',
    },
    /** tooltip */
    tooltip: {
      copyToClipboardDone: 'Copied to clipboard!',
    },
    /** confirm dialog */
    confirmDialog: {
      confirm: 'Save',
      cancel: 'Cancel',
    },
    /** tags manager */
    tagsManager: {
      manageTags: 'Manage tags',
      tagId: 'tag key',
      tagIdPlaceholder: 'Please input tag key',
      tagIdError1: 'tag key is not null!',
      tagIdError2: 'tag key is not 「id」!',
      tagIdError3: 'The maximum length of tag key is 50 characters!',
      tagValue: 'tag value',
      tagValuePlaceholder: 'Please input tag value',
      tagValueError1: 'The maximum length of tag value is 50 characters!',
      addTag: 'Add tag',
      destroy: 'Delete',
      submit: 'Save',
      cancel: 'Cancel',
    },
    /** api error */
    apiError: {
      error401: 'Insufficient permissions',
      error403: 'Insufficient permissions',
      needRelogin: 'login timeout!',
      unexpectedServerError: 'unexpected Server error!',
      API_SERVER_ERROR: 'unexpected API Server error!',
      CAPTCHA_NOT_MATCH: 'Verification code error!',
      /* 常用訊息相關(10000-19999) */
      TRY_AGAIN_LATER: 'The operation is too frequent, please try again later!',
      EMAIL_NOT_EXIST: 'Email does not exist!',
      EMAIL_REPEAT: 'The same duplicate Email already exists!',
      MISSING_DATA: 'Required information is missing!',
      USER_DOES_NOT_HAVE_PERMISSION: 'User does not have permission!',
      DB_HAS_NO_DATA: 'Data not found!',
      EMAIL_REGISTERED: 'This email has registered or in processing!',
      LINK_EXPIRED: 'This link is expired!',
      NETWORK_ERROR: 'Network error!',
      /* 帳號密碼相關(20000-29999) */ 
      LOGIN_ERROR: 'Account or password is wrong!',
      ACCOUNT_NOT_ACTIVATED: 'This account is not Enabled yet!',
      PASSWORD_AGAINST_RULES: 'The password complexity set does not comply with the rules!',
      PASSWORD_CANNOT_RESET: 'Password cannot be reset!',
      PASSWORD_RESET_REPEAT:  'Root Account has applied for a password reset within 24 hours!',
      PASSWORD_RESET_EXPIRED: 'Password reset request has expired!',
      PASSWORD_EXPIRED: 'Password setting expired!',
      PROCESS_APPLY_REPEAT: 'Root Account has applied for Registration Progress Query within 24 hours!',
      PROCESS_APPLY_EXPIRED: 'Registration Progress Query application has expired!',
      REGISTER_VERIFY_ERROR: 'Registration verification error!',
      REGISTER_APPLIED: 'This account application information is already under review!',
      INCORRECT_PASSWORD: 'The password is wrong!',
      VERIFY_CODE_ERROR: 'Verify code error!',
      REPEAT_LOGIN: 'Repeat login!',
      CAN_NOT_FIND_2FA: 'Can\'t find 2FA!',
      /* 權限相關(40000~49999) */
      ACCOUNT_ROLE_NOT_EXIST: 'Account role dismatch!',
      YOU_ARE_NOT_DEFAULT_ASSISTANT: 'You are not the default account!',
      /* 虛擬機相關(50000~50999) */
      VM_STATUS_ERROR: 'Virtual Machine state error',
      VM_NOT_FOUND: 'Could not find Virtual Machine',
      /* 磁碟區相關(51000-51999) */
      DISK_STATUS_ERROR: 'Volume state error',
      DISK_NOT_FOUND: 'Volume not found',
      DISKS_LIMIT_3: 'The upper limit of Data Volume is 3',
      NON_REMOVABLE_ROOT_DISK: 'Root Volume cannot be removed',
      UNABLE_TO_REDUCE_DISK_SIZE: 'Volume size can only be increased.',
      DISK_ALREADY_HAS_A_VM_ATTACHED: 'This Volume is already connected to a Virtual Machine',
      OVER_VM_DISK_LIMIT: 'Over Virtual Machine volume limit',
      /* 網段相關(52000-52999) */
      VPC_ALREADY_HAS_A_VM_ATTACHED: 'This VPC has a Virtual Machine being connected',
      /* 防火牆相關(53000-53999) */
      FIREWALL_ALREADY_HAS_A_VM_ATTACHED: 'This firewall has been related to virtual machine!',
      /* 快照相關(54000-54999) */
      SNAPSHOT_STATUS_ERROR: 'Snapshot status error!',
      /* MV Cloud 相關(6000-60100) */
      PUBLIC_CLOUD_REPEAT: 'This credential already exists, please delete the old credential before adding it!',
      PUBLIC_CLOUD_NOT_EXIST: 'Certification not found!',
      PUBLIC_CLOUD_MISSING_PARAMETERS_GCP: 'GCP data miss!',
      PUBLIC_CLOUD_MISSING_PARAMETERS_AZURE: 'AZURE data miss!',
      PUBLIC_CLOUD_MISSING_PARAMETERS_AWS: 'AWS data miss!',
      /* AmazonS3相關(70000-70999) */
      AMAZON_SERVICE_ERROR: 'S3 service error!',
      BUCKET_NOT_EMPTY: 'The bucket that you tried to delete is not empty!',
      INVALID_ACCESS_KEY_ID: 'The AWS access key ID that you provided does not exist!',
      KEY_TOO_LONG: 'Object key is too long!',
      NO_SUCH_BUCKET: 'The specified bucket does not exist!',
      NO_SUCH_KEY: 'The specified key does not exist!',
      /* 儲存桶相關(71000-71999) */
      ILLEGAL_BUCKET_NAME: 'The bucket name is illegal!',
      INVALID_DIRECTORY: 'Invalid directory!',
      LIFECYCLE_RULE_NOT_FOUND: 'Lifecycle rule not found!',
      /* 驗證相關(90000~) */
      TWO_FA_CODE_ERROR: '2FA verification code error!',
      VERIFY_DATA_ERROR: 'Data verify fault!',
      VERIFY_REGISTER_ASSIGN_ERROR: 'Assign sales failure!',
      VERIFY_REGISTER_REJECT_ERROR: 'Refuse failure!',
      VERIFY_REGISTER_SIGN_FLOW_SIGN_PERSON_ERROR: 'Signer identity incorrect!',
      VERIFY_REGISTER_AGREE_ERROR: 'Agree failure!',
      NOT_HAVE_EMAIL: 'Enable 2FA without email!',
      EMAIL_DOES_NOT_CONFORM_TO_NORMALIZATION: 'Email format incorrect!',
      PASSWORDS_DO_NOT_MATCH: 'Second password doesn\'t match the first one',
      ACCOUNT_HAS_BEEN_DELETED: 'This account has been deleted!',
      ACCOUNT_EXISTS: 'Account exists!',
      EMAIL_EXISTS: 'Email exists!',
      NOT_HAVE_PASSWORD: 'Password require!',
      FIELD_MUST_FILL_IN: 'Field must fill in!',
      FORMAT_ERROR: 'Format error!',
      ACCOUNT_FORMAT_ERROR: 'The account only accepts English, dot and underline!',
      MISS_PARAMETER: 'Miss Parameter!',
      TIME_IS_ERROR: 'The input month does not meet the requirements!',
      STATUS_IS_ERROR: 'The input status does not meet the requirements!',
      PRICE_IS_ERROR: 'Pricing field is missing data!',
      TEMPLATEID_IS_ERROR: 'This master does not exist in the database!',
      CATEGORYID_IS_ERROR: 'This resource type does not exist in the database!',
      NAME_AND_SPECTYPE_UNIQUE_IS_ERROR: 'The same name and type cannot be priced repeatedly!',
      SPECTYPE_TEMPLATE_UNIQUE_IS_ERROR: 'Masters cannot be double priced!',
      TEMPLATE_STATUS_ERROR: '虛擬機母版狀態錯誤！',
      TEMPLATE_ALREADY_EXISTS: '虛擬機母版已存在！',
      USER_NUMBER_EXISTS: 'User number exists!',
      OVER_BASE_USAGE: '超過基礎使用量！',
      PHONE_FORMAT_ERROR: '手機號碼不符合正規化！',
      IPv4_FORMAT_ERROR: 'IP格式錯誤！',
      FIREWALL_IN_NON_MODIFIABLE_STATE: '防火牆處於不可修改狀態！',
      FIREWALL_OVER_LIMIT: '防火牆超過數量限制！',
      CCIS_HOST_ERROR: 'Somethong wrong on CCIS Platform, please try again later!',
      CCIS_EXPEND_BLOCKSIZE_ERROR: 'Purchase failure, please try again later!',
      CCOS_USER_NOT_FOUND: 'User not found on CCIS, please contact the customer service!',
      DATE_MUST_GREATER_THAN_TODAY: 'The date must be greater than today!',
      VPC_ALREADY_EXISTS: 'VPC網段已存在!',
      CCIS_ERROR: 'CCIS Error!',
      CLIENT_NOT_FOUND: 'Client not found!',
      CLIENT_NUMBER_NOT_FOUND: 'Client number not found!',
      ACCOUNT_DISABLE: 'Account disable!',
      ACCOUNT_DELETE: 'Account delete!',
      CCIS_PURCHASE_TOO_OFTEN: 'Only one deal per day!',
      CCIS_PURCHASE_FULL: 'Purchase Quota Full!',
      DEALER_NOT_FOUND: 'Dealer not found!',
      ACCOUNT_IS_LOCK: 'The account is locked, please contact the Root administrator!',
      CCIS_CHANGE_NAME_DUPLICATED: 'Name Duplicated!',
      CCIS_PERIOD_MUST_BE_LONGER: 'Contract period must be longer when commit no change!',
      CCIS_NEW_END_MUST_AFTER_OLD_END: 'New expire date must after old one when expand commit!',
      CCIS_REDUCE_ON_LAST_MONTH: 'Reduce can only be processed on the last 30 days, and take effect after expire day!',
      CCIS_GET_TOKRN_FAIL: 'Login fail on CCIS!',
      CCIS_SET_BLOCKSIZE_FAIL: 'Adjust block size fail!',
      CCIS_GET_BLOCKSIZE_FAIL: 'Get block size fail!',
      CCIS_SOMETHING_WRONG: 'Something wrong on CCIS!',
      MANUAL_METHOD_REQUIRES_THE_USE_OF_THE_IPv4_FORMAT: 'Manual method requires the use of the IPv4 format!',
      YEARLY_VM_CANNOT_ADJUST: 'Yearly VM cannot be adjusted!',
      VM_NEED_SHUTDOWN: 'VM Need Shutdown!',
      A_VM_CAN_ONLY_BE_BOUND_TO_ONE_SNAPSHOT_RULE: 'A VM can only be bound to one snapshot rule!',
    },
  },
};
